window.slate = window.slate || {};
window.theme = window.theme || {};

/*================ Slate ================*/
/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {
	/**
	 * For use when focus shifts to a container rather than a link
	 * eg for In-page links, after scroll, focus shifts to content area so that
	 * next `tab` is where user expects if focusing a link, just $link.focus();
	 *
	 * @param {JQuery} $element - The element to be acted upon
	 */
	pageLinkFocus: function ($element) {
		var focusClass = 'js-focus-hidden';

		$element
			.first()
			.attr('tabIndex', '-1')
			.focus()
			.addClass(focusClass)
			.one('blur', callback);

		function callback() {
			$element.first().removeClass(focusClass).removeAttr('tabindex');
		}
	},

	/**
	 * If there's a hash in the url, focus the appropriate element
	 */
	focusHash: function () {
		var hash = window.location.hash;

		// is there a hash in the url? is it an element on the page?
		if (hash && document.getElementById(hash.slice(1))) {
			this.pageLinkFocus($(hash));
		}
	},

	/**
	 * When an in-page (url w/hash) link is clicked, focus the appropriate element
	 */
	bindInPageLinks: function () {
		$('a[href*=#]').on(
			'click',
			function (evt) {
				this.pageLinkFocus($(evt.currentTarget.hash));
			}.bind(this),
		);
	},

	/**
	 * Traps the focus in a particular container
	 *
	 * @param {object} options - Options to be used
	 * @param {jQuery} options.$container - Container to trap focus within
	 * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
	 * @param {string} options.namespace - Namespace used for new focus event handler
	 */
	trapFocus: function (options) {
		var eventName = options.namespace
			? 'focusin.' + options.namespace
			: 'focusin';

		if (!options.$elementToFocus) {
			options.$elementToFocus = options.$container;
		}

		options.$container.attr('tabindex', '-1');
		options.$elementToFocus.focus();

		$(document).on(eventName, function (evt) {
			if (
				options.$container[0] !== evt.target &&
				!options.$container.has(evt.target).length
			) {
				options.$container.focus();
			}
		});
	},

	/**
	 * Removes the trap of focus in a particular container
	 *
	 * @param {object} options - Options to be used
	 * @param {jQuery} options.$container - Container to trap focus within
	 * @param {string} options.namespace - Namespace used for new focus event handler
	 */
	removeTrapFocus: function (options) {
		var eventName = options.namespace
			? 'focusin.' + options.namespace
			: 'focusin';

		if (options.$container && options.$container.length) {
			options.$container.removeAttr('tabindex');
		}

		$(document).off(eventName);
	},
};

/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
 * @namespace cart
 */

slate.cart = {
	/**
	 * Browser cookies are required to use the cart. This function checks if
	 * cookies are enabled in the browser.
	 */
	cookiesEnabled: function () {
		var cookieEnabled = navigator.cookieEnabled;

		if (!cookieEnabled) {
			document.cookie = 'testcookie';
			cookieEnabled = document.cookie.indexOf('testcookie') !== -1;
		}
		return cookieEnabled;
	},

	initCart: function () {
		$('.cart-icon').click(function (e) {
			e.preventDefault();

			if ($('#mobile-site-nav-list').hasClass('show-menu')) {
				$('#mobile-hamburger-toggle').trigger('click');
			}

			if ($('#mini-cart').hasClass('is-open')) {
				$('#mini-cart').removeClass('is-open');
			} else {
				//window.scroll(0,0);
				$('#mini-cart').addClass('is-open');
			}
		});

		$('.close-cart').click(function (e) {
			e.preventDefault();
			$('#mini-cart').removeClass('is-open');
		});

		if ($('[data-cart-json]').length != 0) {
			this.shopify_cart = JSON.parse($('[data-cart-json]').first().html());
		} else {
			this.shopify_cart = {};
		}
		this.buildMiniCart();

		// set up normal add to cart form
		$('form[action="/cart/add"],form[id="add-to-cart-form"]').submit(
			function (e) {
				e.preventDefault();
				$form = $(this);

				console.log('submit cart');

				// we are adding a gift so remove everything else from the cart
				// if( $form.find('input[name="properties[_is_gift]"]').val() == "1" ) {
				//   $.post('/cart/clear.js', {}, function(data) {
				//     console.log('cleared cart');
				//     slate.cart.submitCartForm($form, function() {
				//       console.log('redirecting ');
				//       window.location.href = '/checkout';
				//     });
				//   }.bind($form), 'json');
				// } else {

				//   // we're adding a non-gift so let's make sure there are no gifts in the cart
				//   var has_gifts = false;
				//   for(var i in slate.cart.shopify_cart.items) {
				//     for(var j in slate.cart.shopify_cart.items[i].properties) {
				//       if(j == '_is_gift' && slate.cart.shopify_cart.items[i].properties[j] == 1 || j == '_is_bundle_gift') {
				//         has_gifts = true;
				//         break;
				//       }
				//     }
				//     if(has_gifts) break;
				//   }

				//   if(has_gifts) {
				//     $.post('/cart/clear.js', {}, function(data) {
				//       slate.cart.submitCartForm($form);
				//     }.bind($form), 'json');
				//   } else {
				//     slate.cart.submitCartForm($form);
				//   }
				// }
				// slate.cart.submitCartForm($form);
				(function (win, doc, sdk_url) {
					if (win.snaptr) return;
					var tr = (win.snaptr = function () {
						tr.handleRequest
							? tr.handleRequest.apply(tr, arguments)
							: tr.queue.push(arguments);
					});
					tr.queue = [];
					var s = 'script';
					var new_script_section = doc.createElement(s);
					new_script_section.async = !0;
					new_script_section.src = sdk_url;
					var insert_pos = doc.getElementsByTagName(s)[0];
					insert_pos.parentNode.insertBefore(new_script_section, insert_pos);
				})(window, document, 'https://sc-static.net/scevent.min.js');
				snaptr('init', '03f8b988-d302-4e42-b1d3-bbdec0c2c67a', {
					user_email: '',
				});
				snaptr('track', 'ADD_CART');
			},
		);
	},

	buildMiniCart: function () {
		$('#mini-cart-items').empty();
		/* now add everything else */
		for (var i in this.shopify_cart.items) {
			// if(this.shopify_cart.items[i].product_type == 'Candles' || this.shopify_cart.items[i].product_type == 'Extras' || this.shopify_cart.items[i].product_type == 'Gift Card') continue;
			if (
				this.shopify_cart.items[i].product_type == 'Extras' ||
				this.shopify_cart.items[i].product_type == 'Gift Card'
			)
				continue;
			//if(this.shopify_cart.items[i].handle.indexOf('-platform') !== -1) continue;

			var sub_item = false;
			for (var p in this.shopify_cart.items[i].properties) {
				if (p == '_parent') {
					sub_item = this.shopify_cart.items[i].properties[p];
					break;
				}
			}
			// add a hidden list item for the sub items that may have been unaccounted for
			if (
				sub_item !== false &&
				$('#item-' + this.shopify_cart.items[i].key).length == 0
			) {
				var regular_item =
					'<li class="hidden-sub-item" style="display:none;" id="item-' +
					this.shopify_cart.items[i].key +
					'" data-handle="' +
					this.shopify_cart.items[i].handle +
					'" data-parent-line="' +
					sub_item +
					'" data-variant-id="' +
					this.shopify_cart.items[k].id +
					'" data-sub-line="' +
					parseInt(i) +
					'">&nbsp;</li>';
			} else {
				var is_gift = false;
				for (var j in this.shopify_cart.items[i].properties) {
					if (
						j == '_is_gift' &&
						this.shopify_cart.items[i].properties[j] == 1
					) {
						is_gift = true;
						break;
					}
				}

				var price =
					'<span class="final-line-price">$' +
					(this.shopify_cart.items[i].final_line_price / 100)
						.toString()
						.replace('.00', '') +
					'</span>';

				if (
					this.shopify_cart.items[i].original_line_price >
					this.shopify_cart.items[i].final_line_price
				) {
					price =
						'<strike>$' +
						(this.shopify_cart.items[i].original_line_price / 100)
							.toString()
							.replace('.00', '') +
						'</strike>' +
						price;
				}

				var regular_item =
					'<li id="item-' +
					this.shopify_cart.items[i].key +
					'" data-handle="' +
					this.shopify_cart.items[i].handle +
					'">' +
					'<a class="product-image" href="' +
					this.shopify_cart.items[i].url +
					'">' +
					'<img src="' +
					this.shopify_cart.items[i].image +
					'" border="0" />' +
					'</a>' +
					'<h6 class="mini-heading remove-item"><a href="javascript:void(0)" data-quantity="' +
					this.shopify_cart.items[i].quantity +
					'" data-key="' +
					this.shopify_cart.items[i].key +
					'" data-line="' +
					parseInt(i) +
					'">Remove</a></h6>' +
					'<h6' +
					(this.shopify_cart.items[i].image
						? ' class="product-title-with-image"'
						: '') +
					'>' +
					this.shopify_cart.items[i].title +
					(is_gift ? ' (gift)' : '') +
					'</h6>' +
					'<div class="quantity-container">' +
					'<input type="number" id="quantity-' +
					this.shopify_cart.items[i].key +
					'" name="quantity" value="' +
					this.shopify_cart.items[i].quantity +
					'" min="1" max="9" pattern="/d*" maxlength="1" autocomplete="off" data-quantity="' +
					this.shopify_cart.items[i].quantity +
					'" data-key="' +
					this.shopify_cart.items[i].key +
					'" data-line="' +
					parseInt(i) +
					'"' +
					(is_gift ? 'class="disabled" disabled="disabled"' : '') +
					'>' +
					'<p class="price-container"><span>' +
					price +
					'</span></p>' +
					'</div>' +
					'<div style="clear:both;height:0px;">&nbsp;</div>' +
					'</li>';
			}
			$('#mini-cart-items').append(regular_item);
		}

		// set up mini-cart remove
		$('#mini-cart .remove-item > a').click(function () {
			$link = $(this);

			var updates = {};
			updates[$link.attr('data-line')] = 0;
			$('li[data-parent-line="' + $link.attr('data-line') + '"]').each(
				function () {
					updates[$(this).attr('data-sub-line')] = 0;
				},
			);
			slate.cart.updateLines(updates);
		});

		// set up mini-cart quantity
		$('#mini-cart input[type="number"][name="quantity"]').change(function () {
			var $input = $(this);
			var new_quantity = parseInt($input.val());
			if (new_quantity == $input.attr('data-quantity')) return;

			if (new_quantity == 0) $(this).val($input.attr('data-quantity'));

			var updates = {};
			updates[$input.attr('data-line')] = new_quantity;
			$('li[data-parent-line="' + $input.attr('data-line') + '"]').each(
				function () {
					updates[$(this).attr('data-sub-line')] = new_quantity;
				},
			);
			slate.cart.updateLines(updates);
		});

		// update totals
		this.updateTotals();
	},

	updateLines: function (updates, callback) {
		console.log('updateLines: attempt');
		//console.log(updates);

		var formatted_updates = [];
		for (var i in this.shopify_cart.items) {
			if (updates[i] !== undefined) {
				formatted_updates.push(updates[i]);
			} else {
				formatted_updates.push(this.shopify_cart.items[i].quantity);
			}
		}

		$.post(
			'/cart/update.js',
			{ updates: formatted_updates },
			function (data) {
				console.log('updateLines: success');
				//console.log(data);
				if (typeof callback == 'function') {
					callback(data);
				} else {
					slate.cart.shopify_cart = data;
					slate.cart.buildMiniCart();
				}
			},
			'json',
		).fail(function (data) {
			console.log('updateLines: failed');
			//console.log(data);
			slate.cart.buildMiniCart();
		});
	},

	updateTotals: function () {
		var total_items = 0;
		$('#mini-cart-items > li:not(.hidden-sub-item)').each(function () {
			total_items += parseInt(
				$(this).find('input[name="quantity"]').first().val(),
			);
		});

		var $cartIcon = $('.cart-icon');
		var $count = $cartIcon.find('.cart-icon__count');
		var srOnlyText =
			total_items === 0
				? 'View cart'
				: 'View cart, ' +
					total_items +
					' item' +
					(total_items !== 1 ? 's' : '');

		$count.text(total_items);
		$cartIcon.attr('aria-label', srOnlyText);
		// $cartIcon.find('.sr-only').text(srOnlyText);

		if (total_items == 0) {
			$cartIcon.removeClass('has-items');
			$('#mini-cart-items .no-items-message').show();
			$('#mini-cart').addClass('no-items');
			$('#mini-cart .price-container > span').text('$0');
		} else {
			$cartIcon.addClass('has-items');
			$('#mini-cart-items .no-items-message').hide();
			$('#mini-cart').removeClass('no-items');

			var total_price = 0;
			$('#mini-cart-items > li:not(.hidden-sub-item)').each(function () {
				total_price += parseFloat(
					$(this)
						.find('.price-container .final-line-price')
						.text()
						.replace('$', ''),
				);
			});

			$('#mini-cart .mini-cart-footer .price-container > span').text(
				'$' + total_price.toString().replace('.00', '').replace('.0', ''),
			);
		}
	},

	submitCartForm: function ($form, callback) {
		$originaltext = $form
			.find('[type="submit"] > [data-add-to-cart-text]')
			.text();
		$form
			.find('[type="submit"] > [data-add-to-cart-text]')
			.attr('data-original-text', $originaltext)
			.text('Adding...')
			.addClass('disabled')
			.prop('disabled', true);
		//var bundle = parseInt($form.find('[name="properties[_bundle]"]').val());
		//console.log('bundle:', bundle, OTHERLAND.standard_packaging, 'sup: ', OTHERLAND.eco_friendly_packaging_single);
		// var isEco = false;
		// var platForm = '';

		// find additional IDs and add them
		//$form.find('.more_ids').remove();
		$form.find('.additional_id_added').remove();
		$form.find('.additional_ids').each(function (idx) {
			var id = parseInt($(this).val());
			//var id = null;

			// var variant = OTHERLAND.eco_friendly_variants.filter(function(x){
			//   return x.variant_id === val || x.eco_friendly_variant_id === val
			// });

			//console.log(idx, $(this), val, 'variant:', variant);
			//idx = idx+1;
			//var $htmlId = $(this).attr('id');
			//id = $(this).val();

			// //Ensure proper variants (Standard or Eco-Friendly) for selected scents are added to order
			// if($htmlId === 'candle_1_variant_id' || $htmlId === 'candle_2_variant_id' || $htmlId === 'candle_3_variant_id' || $htmlId === 'candle_4_variant_id' || $htmlId === 'candle_5_variant_id' || $htmlId === 'candle_6_variant_id'){
			//   if((bundle === OTHERLAND.eco_friendly_packaging || bundle === OTHERLAND.eco_friendly_packaging_single || bundle === OTHERLAND.eco_friendly_packaging_six_pack) && variant[0] != null){
			//     id = variant[0].eco_friendly_variant_id;
			//     //TODO: Make sure variant is in stock, if not default to other variant, and packaging option
			//     $form.find('input[type="hidden"][name="properties[_' + $htmlId + ']"]').val(id);
			//     //$form.append('<input class="additional_id_added" type="hidden" name="properties[_candle_' + idx + '_variant_id]" value="' + id + '" />');
			//     isEco = true;
			//     platForm = $form.find('[name="properties[_platform]"]').val();
			//   } else if(bundle === OTHERLAND.standard_packaging || bundle === OTHERLAND.standard_packaging_single || bundle === OTHERLAND.standard_packaging_six_pack || bundle === OTHERLAND.holiday_packaging || bundle === OTHERLAND.holiday_packaging_single || bundle === OTHERLAND.holiday_packaging_six_pack && $(this).val() !== ''){
			//     id = $(this).val();
			//     //TODO: Make sure variant is in stock, if not default to other variant, and packaging option
			//     $form.find('input[type="hidden"][name="properties[_' + $htmlId + ']"]').val(id);
			//     //$form.append('<input class="additional_id_added" type="hidden" name="properties[_candle_' + idx + '_variant_id]" value="' + id + '" />');
			//   }
			// } else if($(this).val() !== '') {
			//   id = $(this).val();
			// }

			if (id != null && id !== '') {
				$form.append(
					'<input class="additional_id_added" type="hidden" name="id[]" value="' +
						id +
						'" />',
				);
			}
		});

		$form.find('[name="id"]').attr('name', 'id[]');

		//If eco-friendly, remove platform
		// if(isEco){
		//   $form.find('.additional_id_added[value="' + platForm +'"]').remove();
		// }

		$.post(
			'/cart/add.js',
			$form.serialize(),
			function (data) {
				console.log('addItemToCart: success');
				//console.log(data);

				if (typeof callback == 'function') {
					callback(data);
				} else {
					$.get(
						'/cart.js',
						{},
						function (data) {
							slate.cart.shopify_cart = data;
							slate.cart.buildMiniCart();
							$('#mini-cart').addClass('is-open');
						},
						'json',
					);

					$form
						.find('[type="submit"] > [data-add-to-cart-text]')
						.text('Added!');
					window.setTimeout(function () {
						$form
							.find('[type="submit"] > [data-add-to-cart-text]')
							.text(
								$form
									.find('[type="submit"] > [data-add-to-cart-text]')
									.attr('data-original-text'),
							)
							.prop('disabled', false)
							.removeClass('disabled');
					}, 20000);
				}
			},
			'json',
		).fail(function (data) {
			console.log('addItemToCart: error');
			//console.log(data);
			$form.find('[type="submit"] > [data-add-to-cart-text]').text('Sold Out');
			window.setTimeout(function () {
				$form
					.find('[type="submit"] > [data-add-to-cart-text]')
					.text(
						$form
							.find('[type="submit"] > [data-add-to-cart-text]')
							.attr('data-original-text'),
					)
					.prop('disabled', false)
					.removeClass('disabled');
			}, 1000);
		});
	},
};

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {
	/**
	 * Return an object from an array of objects that matches the provided key and value
	 *
	 * @param {array} array - Array of objects
	 * @param {string} key - Key to match the value against
	 * @param {string} value - Value to get match of
	 */
	findInstance: function (array, key, value) {
		for (var i = 0; i < array.length; i++) {
			if (array[i][key] === value) {
				return array[i];
			}
		}
	},

	/**
	 * Remove an object from an array of objects by matching the provided key and value
	 *
	 * @param {array} array - Array of objects
	 * @param {string} key - Key to match the value against
	 * @param {string} value - Value to get match of
	 */
	removeInstance: function (array, key, value) {
		var i = array.length;
		while (i--) {
			if (array[i][key] === value) {
				array.splice(i, 1);
				break;
			}
		}

		return array;
	},

	/**
	 * _.compact from lodash
	 * Remove empty/false items from array
	 * Source: https://github.com/lodash/lodash/blob/master/compact.js
	 *
	 * @param {array} array
	 */
	compact: function (array) {
		var index = -1;
		var length = array == null ? 0 : array.length;
		var resIndex = 0;
		var result = [];

		while (++index < length) {
			var value = array[index];
			if (value) {
				result[resIndex++] = value;
			}
		}
		return result;
	},

	/**
	 * _.defaultTo from lodash
	 * Checks `value` to determine whether a default value should be returned in
	 * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
	 * or `undefined`.
	 * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
	 *
	 * @param {*} value - Value to check
	 * @param {*} defaultValue - Default value
	 * @returns {*} - Returns the resolved value
	 */
	defaultTo: function (value, defaultValue) {
		return value == null || value !== value ? defaultValue : value;
	},
};

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap videos in div to force responsive layout.
 *
 * @namespace rte
 */

slate.rte = {
	wrapTable: function () {
		$('.rte table').wrap('<div class="rte__table-wrapper"></div>');
	},

	iframeReset: function () {
		var $iframeVideo = $(
			'.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"]',
		);
		var $iframeReset = $iframeVideo.add('.rte iframe#admin_bar_iframe');

		$iframeVideo.each(function () {
			// Add wrapper to make video responsive
			$(this).wrap('<div class="rte__video-wrapper"></div>');
		});

		$iframeReset.each(function () {
			// Re-set the src attribute on each iframe after page load
			// for Chrome's "incorrect iFrame content on 'back'" bug.
			// https://code.google.com/p/chromium/issues/detail?id=395791
			// Need to specifically target video and admin bar
			this.src = this.src;
		});
	},
};

slate.Sections = function Sections() {
	this.constructors = {};
	this.instances = [];

	$(document)
		.on('shopify:section:load', this._onSectionLoad.bind(this))
		.on('shopify:section:unload', this._onSectionUnload.bind(this))
		.on('shopify:section:select', this._onSelect.bind(this))
		.on('shopify:section:deselect', this._onDeselect.bind(this))
		.on('shopify:section:reorder', this._onReorder.bind(this))
		.on('shopify:block:select', this._onBlockSelect.bind(this))
		.on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
	_createInstance: function (container, constructor) {
		var $container = $(container);
		var id = $container.attr('data-section-id');
		var type = $container.attr('data-section-type');

		constructor = constructor || this.constructors[type];

		if (typeof constructor === 'undefined') {
			return;
		}

		var instance = $.extend(new constructor(container), {
			id: id,
			type: type,
			container: container,
		});

		this.instances.push(instance);
	},

	_onSectionLoad: function (evt) {
		var container = $('[data-section-id]', evt.target)[0];
		if (container) {
			this._createInstance(container);
		}
	},

	_onSectionUnload: function (evt) {
		var instance = slate.utils.findInstance(
			this.instances,
			'id',
			evt.detail.sectionId,
		);

		if (!instance) {
			return;
		}

		if (typeof instance.onUnload === 'function') {
			instance.onUnload(evt);
		}

		this.instances = slate.utils.removeInstance(
			this.instances,
			'id',
			evt.detail.sectionId,
		);
	},

	_onSelect: function (evt) {
		var instance = slate.utils.findInstance(
			this.instances,
			'id',
			evt.detail.sectionId,
		);

		if (instance && typeof instance.onSelect === 'function') {
			instance.onSelect(evt);
		}
	},

	_onDeselect: function (evt) {
		var instance = slate.utils.findInstance(
			this.instances,
			'id',
			evt.detail.sectionId,
		);

		if (instance && typeof instance.onDeselect === 'function') {
			instance.onDeselect(evt);
		}
	},

	_onReorder: function (evt) {
		var instance = slate.utils.findInstance(
			this.instances,
			'id',
			evt.detail.sectionId,
		);

		if (instance && typeof instance.onReorder === 'function') {
			instance.onReorder(evt);
		}
	},

	_onBlockSelect: function (evt) {
		var instance = slate.utils.findInstance(
			this.instances,
			'id',
			evt.detail.sectionId,
		);

		if (instance && typeof instance.onBlockSelect === 'function') {
			instance.onBlockSelect(evt);
		}
	},

	_onBlockDeselect: function (evt) {
		var instance = slate.utils.findInstance(
			this.instances,
			'id',
			evt.detail.sectionId,
		);

		if (instance && typeof instance.onBlockDeselect === 'function') {
			instance.onBlockDeselect(evt);
		}
	},

	register: function (type, constructor) {
		this.constructors[type] = constructor;

		$('[data-section-type=' + type + ']').each(
			function (index, container) {
				this._createInstance(container, constructor);
			}.bind(this),
		);
	},
});

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = (function () {
	var moneyFormat = '${{amount}}';

	/**
	 * Format money values based on your shop currency settings
	 * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
	 * or 3.00 dollars
	 * @param  {String} format - shop money_format setting
	 * @return {String} value - formatted value
	 */
	function formatMoney(cents, format) {
		if (typeof cents === 'string') {
			cents = cents.replace('.', '');
		}
		var value = '';
		var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
		var formatString = format || moneyFormat;

		function formatWithDelimiters(number, precision, thousands, decimal) {
			precision = slate.utils.defaultTo(precision, 2);
			thousands = slate.utils.defaultTo(thousands, ',');
			decimal = slate.utils.defaultTo(decimal, '.');

			if (isNaN(number) || number == null) {
				return 0;
			}

			number = (number / 100.0).toFixed(precision);

			var parts = number.split('.');
			var dollarsAmount = parts[0].replace(
				/(\d)(?=(\d\d\d)+(?!\d))/g,
				'$1' + thousands,
			);
			var centsAmount = parts[1] ? decimal + parts[1] : '';

			return dollarsAmount + centsAmount;
		}

		switch (formatString.match(placeholderRegex)[1]) {
			case 'amount':
				value = formatWithDelimiters(cents, 2);
				break;
			case 'amount_no_decimals':
				value = formatWithDelimiters(cents, 0);
				break;
			case 'amount_with_space_separator':
				value = formatWithDelimiters(cents, 2, ' ', '.');
				break;
			case 'amount_no_decimals_with_comma_separator':
				value = formatWithDelimiters(cents, 0, ',', '.');
				break;
			case 'amount_no_decimals_with_space_separator':
				value = formatWithDelimiters(cents, 0, ' ');
				break;
		}

		return formatString.replace(placeholderRegex, value);
	}

	return {
		formatMoney: formatMoney,
	};
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

slate.Image = (function () {
	/**
	 * Preloads an image in memory and uses the browsers cache to store it until needed.
	 *
	 * @param {Array} images - A list of image urls
	 * @param {String} size - A shopify image size attribute
	 */

	function preload(images, size) {
		if (typeof images === 'string') {
			images = [images];
		}

		for (var i = 0; i < images.length; i++) {
			var image = images[i];
			this.loadImage(this.getSizedImageUrl(image, size));
		}
	}

	/**
	 * Loads and caches an image in the browsers cache.
	 * @param {string} path - An image url
	 */
	function loadImage(path) {
		new Image().src = path;
	}

	/**
	 * Find the Shopify image attribute size
	 *
	 * @param {string} src
	 * @returns {null}
	 */
	function imageSize(src) {
		var match = src.match(
			/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/,
		);

		if (match) {
			return match[1];
		} else {
			return null;
		}
	}

	/**
	 * Adds a Shopify size attribute to a URL
	 *
	 * @param src
	 * @param size
	 * @returns {*}
	 */
	function getSizedImageUrl(src, size) {
		if (size === null) {
			return src;
		}

		if (size === 'master') {
			return this.removeProtocol(src);
		}

		var match = src.match(
			/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i,
		);

		if (match) {
			var prefix = src.split(match[0]);
			var suffix = match[0];

			return this.removeProtocol(prefix[0] + '_' + size + suffix);
		} else {
			return null;
		}
	}

	function removeProtocol(path) {
		return path.replace(/http(s)?:/, '');
	}

	return {
		preload: preload,
		loadImage: loadImage,
		imageSize: imageSize,
		getSizedImageUrl: getSizedImageUrl,
		removeProtocol: removeProtocol,
	};
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function () {
	/**
	 * Variant constructor
	 *
	 * @param {object} options - Settings from `product.js`
	 */
	function Variants(options) {
		this.$container = options.$container;
		this.product = options.product;
		this.singleOptionSelector = options.singleOptionSelector;
		this.originalSelectorId = options.originalSelectorId;
		this.enableHistoryState = options.enableHistoryState;
		this.currentVariant = this._getVariantFromOptions();

		$(this.singleOptionSelector, this.$container).on(
			'change',
			this._onSelectChange.bind(this),
		);
	}

	Variants.prototype = $.extend({}, Variants.prototype, {
		/**
		 * Get the currently selected options from add-to-cart form. Works with all
		 * form input elements.
		 *
		 * @return {array} options - Values of currently selected variants
		 */
		_getCurrentOptions: function () {
			var currentOptions = $.map(
				$(this.singleOptionSelector, this.$container),
				function (element) {
					var $element = $(element);
					var type = $element.attr('type');
					var currentOption = {};

					if (type === 'radio' || type === 'checkbox') {
						if ($element[0].checked) {
							currentOption.value = $element.val();
							currentOption.index = $element.data('index');

							return currentOption;
						} else {
							return false;
						}
					} else {
						currentOption.value = $element.val();
						currentOption.index = $element.data('index');

						return currentOption;
					}
				},
			);

			// remove any unchecked input values if using radio buttons or checkboxes
			currentOptions = slate.utils.compact(currentOptions);

			return currentOptions;
		},

		/**
		 * Find variant based on selected values.
		 *
		 * @param  {array} selectedValues - Values of variant inputs
		 * @return {object || undefined} found - Variant object from product.variants
		 */
		_getVariantFromOptions: function () {
			var selectedValues = this._getCurrentOptions();
			var variants = this.product.variants;
			var found = false;

			variants.forEach(function (variant) {
				var satisfied = true;

				selectedValues.forEach(function (option) {
					if (satisfied) {
						satisfied = option.value === variant[option.index];
					}
				});

				if (satisfied) {
					found = variant;
				}
			});

			return found || null;
		},

		/**
		 * Event handler for when a variant input changes.
		 */
		_onSelectChange: function () {
			var variant = this._getVariantFromOptions();

			this.$container.trigger({
				type: 'variantChange',
				variant: variant,
			});

			if (!variant) {
				return;
			}

			this._updateMasterSelect(variant);
			this._updateImages(variant);
			this._updatePrice(variant);
			this.currentVariant = variant;

			if (this.enableHistoryState) {
				this._updateHistoryState(variant);
			}
		},

		/**
		 * Trigger event when variant image changes
		 *
		 * @param  {object} variant - Currently selected variant
		 * @return {event}  variantImageChange
		 */
		_updateImages: function (variant) {
			var variantImage = variant.featured_image || {};
			var currentVariantImage = this.currentVariant.featured_image || {};

			if (
				!variant.featured_image ||
				variantImage.src === currentVariantImage.src
			) {
				return;
			}

			this.$container.trigger({
				type: 'variantImageChange',
				variant: variant,
			});
		},

		/**
		 * Trigger event when variant price changes.
		 *
		 * @param  {object} variant - Currently selected variant
		 * @return {event} variantPriceChange
		 */
		_updatePrice: function (variant) {
			if (
				variant.price === this.currentVariant.price &&
				variant.compare_at_price === this.currentVariant.compare_at_price
			) {
				return;
			}

			this.$container.trigger({
				type: 'variantPriceChange',
				variant: variant,
			});
		},

		/**
		 * Update history state for product deeplinking
		 *
		 * @param  {variant} variant - Currently selected variant
		 * @return {k}         [description]
		 */
		_updateHistoryState: function (variant) {
			if (!history.replaceState || !variant) {
				return;
			}

			var newurl =
				window.location.protocol +
				'//' +
				window.location.host +
				window.location.pathname +
				'?variant=' +
				variant.id;
			window.history.replaceState({ path: newurl }, '', newurl);
		},

		/**
		 * Update hidden master select of variant change
		 *
		 * @param  {variant} variant - Currently selected variant
		 */
		_updateMasterSelect: function (variant) {
			$(this.originalSelectorId, this.$container)[0].value = variant.id;
		},
	});

	return Variants;
})();

/*================ Sections ================*/
/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
 * @namespace product
 */

theme.Product = (function () {
	var selectors = {
		addToCart: '[data-add-to-cart]',
		addToCartText: '[data-add-to-cart-text]',
		comparePrice: '[data-compare-price]',
		comparePriceText: '[data-compare-text]',
		originalSelectorId: '[data-product-select]',
		priceWrapper: '[data-price-wrapper]',
		productFeaturedImage: '[data-product-featured-image]',
		productJson: '[data-product-json]',
		productPrice: '[data-product-price]',
		productThumbs: '[data-product-single-thumbnail]',
		singleOptionSelector: '[data-single-option-selector]',
	};

	/**
	 * Product section constructor. Runs on page load as well as Theme Editor
	 * `section:load` events.
	 * @param {string} container - selector for the section container DOM element
	 */
	function Product(container) {
		this.$container = $(container);

		// Stop parsing if we don't have the product json script tag when loading
		// section in the Theme Editor
		if (!$(selectors.productJson, this.$container).html()) {
			return;
		}

		var sectionId = this.$container.attr('data-section-id');
		this.productSingleObject = JSON.parse(
			$(selectors.productJson, this.$container).html(),
		);
		var options = {
			$container: this.$container,
			enableHistoryState: this.$container.data('enable-history-state') || false,
			singleOptionSelector: selectors.singleOptionSelector,
			originalSelectorId: selectors.originalSelectorId,
			product: this.productSingleObject,
		};

		this.settings = {};
		this.namespace = '.product';
		this.variants = new slate.Variants(options);
		this.$featuredImage = $(selectors.productFeaturedImage, this.$container);

		this.$container.on(
			'variantChange' + this.namespace,
			this.updateAddToCartState.bind(this),
		);
		this.$container.on(
			'variantPriceChange' + this.namespace,
			this.updateProductPrices.bind(this),
		);

		if (this.$featuredImage.length > 0) {
			this.settings.imageSize = slate.Image.imageSize(
				this.$featuredImage.attr('src'),
			);
			slate.Image.preload(
				this.productSingleObject.images,
				this.settings.imageSize,
			);

			this.$container.on(
				'variantImageChange' + this.namespace,
				this.updateProductImage.bind(this),
			);
		}

		// preload images
		$('.product-image img').each(function () {
			var i = new Image();
			i.src = $(this).attr('src');
		});

		$('.product-image').swipe({
			//Generic swipe handler for all directions
			swipe: function (
				e,
				direction,
				distance,
				duration,
				fingerCount,
				finterData,
			) {
				if (direction == 'right') {
					if ($('.product-image-pagination > a.selected').prev().length > 0) {
						$('.product-image-pagination > a.selected')
							.prev()
							.trigger('click', ['right', 500]);
					} else {
						$('.product-image-pagination > a:last').trigger('click', [
							'right',
							500,
						]);
					}
				} else {
					if ($('.product-image-pagination > a.selected').next().length > 0) {
						$('.product-image-pagination > a.selected')
							.next()
							.trigger('click', ['left', 500]);
					} else {
						$('.product-image-pagination > a:first').trigger('click', [
							'left',
							500,
						]);
					}
				}
			},
			//Default is 75px, set to 0 for demo so any distance triggers swipe
			threshold: 10,
		});

		$('.product-image-pagination > a').on(
			'click',
			function (e, direction, timing) {
				e.preventDefault();

				if (timing == undefined) timing = 500;

				$visibleImage = $(this)
					.closest('.product-image')
					.find('img:visible')
					.first();
				$clickedImage = $(this)
					.closest('.product-image')
					.find(
						'#product-image-' +
							($(this).closest('.product-image').find('a').index($(this)) + 1),
					);
				if (direction == 'right') {
					$visibleImage.hide('fade', {}, timing);
					$clickedImage.show('fade', {}, timing);
				} else {
					$visibleImage.hide('fade', {}, timing);
					$clickedImage.show('fade', {}, timing);
				}

				$('.product-image-pagination > a').removeClass('selected');
				$(this).addClass('selected');
			},
		);
	}

	Product.prototype = $.extend({}, Product.prototype, {
		/**
		 * Updates the DOM state of the add to cart button
		 *
		 * @param {boolean} enabled - Decides whether cart is enabled or disabled
		 * @param {string} text - Updates the text notification content of the cart
		 */
		updateAddToCartState: function (evt) {
			var variant = evt.variant;

			if (variant) {
				$(selectors.priceWrapper, this.$container).removeClass('hide');
			} else {
				$(selectors.addToCart, this.$container).prop('disabled', true);
				$(selectors.addToCartText, this.$container).html(
					theme.strings.unavailable,
				);
				$(selectors.priceWrapper, this.$container).addClass('hide');
				return;
			}

			if (variant.available) {
				$(selectors.addToCart, this.$container).prop('disabled', false);
				$(selectors.addToCartText, this.$container).html(
					theme.strings.addToCart,
				);
			} else {
				$(selectors.addToCart, this.$container).prop('disabled', true);
				$(selectors.addToCartText, this.$container).html(theme.strings.soldOut);
			}
		},

		/**
		 * Updates the DOM with specified prices
		 *
		 * @param {string} productPrice - The current price of the product
		 * @param {string} comparePrice - The original price of the product
		 */
		updateProductPrices: function (evt) {
			var variant = evt.variant;
			var $comparePrice = $(selectors.comparePrice, this.$container);
			var $compareEls = $comparePrice.add(
				selectors.comparePriceText,
				this.$container,
			);

			$(selectors.productPrice, this.$container).html(
				slate.Currency.formatMoney(variant.price, theme.moneyFormat),
			);

			if (variant.compare_at_price > variant.price) {
				$comparePrice.html(
					slate.Currency.formatMoney(
						variant.compare_at_price,
						theme.moneyFormat,
					),
				);
				$compareEls.removeClass('hide');
			} else {
				$comparePrice.html('');
				$compareEls.addClass('hide');
			}
		},

		/**
		 * Updates the DOM with the specified image URL
		 *
		 * @param {string} src - Image src URL
		 */
		updateProductImage: function (evt) {
			var variant = evt.variant;
			var sizedImgUrl = slate.Image.getSizedImageUrl(
				variant.featured_image.src,
				this.settings.imageSize,
			);

			this.$featured_image.attr('src', sizedImgUrl);
		},

		/**
		 * Event callback for Theme Editor `section:unload` event
		 */
		onUnload: function () {
			this.$container.off(this.namespace);
		},
	});

	return Product;
})();

/*================ Templates ================*/
/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Addresses
 * template.
 *
 * @namespace customerAddresses
 */

theme.customerAddresses = (function () {
	var $newAddressForm = $('#AddressNewForm');

	if (!$newAddressForm.length) {
		return;
	}

	// Initialize observers on address selectors, defined in shopify_common.js
	if (Shopify) {
		new Shopify.CountryProvinceSelector(
			'AddressCountryNew',
			'AddressProvinceNew',
			{
				hideElement: 'AddressProvinceContainerNew',
			},
		);
	}

	// Initialize each edit form's country/province selector
	$('.address-country-option').each(function () {
		var formId = $(this).data('form-id');
		var countrySelector = 'AddressCountry_' + formId;
		var provinceSelector = 'AddressProvince_' + formId;
		var containerSelector = 'AddressProvinceContainer_' + formId;

		new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
			hideElement: containerSelector,
		});
	});

	// Toggle new/edit address forms
	$('.address-new-toggle').on('click', function () {
		$newAddressForm.toggleClass('hide');
	});

	$('.address-edit-toggle').on('click', function () {
		var formId = $(this).data('form-id');
		$('#EditAddress_' + formId).toggleClass('hide');
	});

	$('.address-delete').on('click', function () {
		var $el = $(this);
		var formId = $el.data('form-id');
		var confirmMessage = $el.data('confirm-message');
		if (
			confirm(confirmMessage || 'Are you sure you wish to delete this address?')
		) {
			Shopify.postLink('/account/addresses/' + formId, {
				parameters: { _method: 'delete' },
			});
		}
	});
})();

/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

theme.customerLogin = (function () {
	var config = {
		recoverPasswordForm: '#RecoverPassword',
		hideRecoverPasswordLink: '#HideRecoverPasswordLink',
	};

	if (!$(config.recoverPasswordForm).length) {
		return;
	}

	checkUrlHash();
	resetPasswordSuccess();

	$(config.recoverPasswordForm).on('click', onShowHidePasswordForm);
	$(config.hideRecoverPasswordLink).on('click', onShowHidePasswordForm);

	function onShowHidePasswordForm(evt) {
		evt.preventDefault();
		toggleRecoverPasswordForm();
	}

	function checkUrlHash() {
		var hash = window.location.hash;

		// Allow deep linking to recover password form
		if (hash === '#recover') {
			toggleRecoverPasswordForm();
		}
	}

	/**
	 *  Show/Hide recover password form
	 */
	function toggleRecoverPasswordForm() {
		$('#RecoverPasswordForm').toggleClass('hide');
		$('#CustomerLoginForm').toggleClass('hide');
	}

	/**
	 *  Show reset password success message
	 */
	function resetPasswordSuccess() {
		var $formState = $('.reset-password-success');

		// check if reset password form was successfully submited.
		if (!$formState.length) {
			return;
		}

		// show success message
		$('#ResetSuccess').removeClass('hide');
	}
})();

document.ontouchstart = function () {
	$('.mobile-site-nav-bottom').animate({ bottom: 0 }, 1);
};

var hovered_over_menu = null;
$(document).ready(function () {
	// enable banner videos
	$('.background-video-player').vimeo_player();

	$('.site-nav--has-submenu > a, .header-menu__button').on(
		'mouseover',
		function () {
			const $trigger = $(this);
			const handle =
				$trigger.attr('data-handle') ||
				$trigger.attr('aria-controls')?.replace('submenu-', '') ||
				$trigger.attr('aria-controls')?.replace('-menu', '');

			hovered_over_menu = handle;

			const $submenu = $('.site-nav__submenu[data-handle="' + handle + '"]');
			$submenu.css('left', $trigger.offset().left).addClass('submenu--is-open');

			// Update both <a> and <button>
			$(
				'.site-nav--has-submenu > a[data-handle="' +
					handle +
					'"], .header-menu__button[aria-controls="' +
					handle +
					'"]',
			)
				.addClass('submenu--is-open')
				.attr('aria-expanded', 'true');
		},
	);

	$('.site-nav__submenu').on('mouseover', function (e) {
		hovered_over_menu = $(this).attr('data-handle');
	});

	$('.site-nav--has-submenu, .site-nav__submenu').on('mouseout', function () {
		const $this = $(this);
		const handle = $this.attr('data-handle');

		hovered_over_menu = null;

		setTimeout(() => {
			if (!hovered_over_menu || hovered_over_menu !== handle) {
				$('.site-nav__submenu[data-handle="' + handle + '"]').removeClass(
					'submenu--is-open',
				);

				$(
					'.site-nav--has-submenu > a[data-handle="' +
						handle +
						'"], .header-menu__button[aria-controls="' +
						handle +
						'"]',
				)
					.removeClass('submenu--is-open')
					.attr('aria-expanded', 'false');
			}
		}, 200);
	});

	function toggleSubmenu(handle, $trigger, moveFocusIntoSubmenu = false) {
		const $submenu = $('.site-nav__submenu[data-handle="' + handle + '"]');
		const $triggerLink = $(
			'.site-nav--has-submenu > a[data-handle="' + handle + '"]',
		);
		const $triggerButton = $(
			'.header-menu__button[aria-controls="' + handle + '"]',
		);

		function getFocusableElements($container) {
			return $container
				.find(
					'a[href], button:not([disabled]), textarea, input:not([type="hidden"]):not([disabled]), select, [tabindex]:not([tabindex="-1"])',
				)
				.filter(':visible');
		}

		const isOpen = $submenu.hasClass('submenu--is-open');

		if (isOpen) {
			// --- CLOSE: remove classes and unbind all handlers ---
			$submenu.removeClass('submenu--is-open').removeAttr('tabindex');

			$triggerLink
				.removeClass('submenu--is-open')
				.attr('aria-expanded', 'false');

			$triggerButton
				.removeClass('submenu--is-open')
				.attr('aria-expanded', 'false');

			// Unbind everything we bound when opening
			$submenu.off('.submenuTrap');
			$(document).off('keydown.submenuEscape');
		} else {
			// --- OPEN: add classes and bind handlers ---
			$submenu
				.css('left', $trigger.offset().left)
				.addClass('submenu--is-open')
				.attr('tabindex', '-1');

			$triggerLink.addClass('submenu--is-open').attr('aria-expanded', 'true');

			$triggerButton.addClass('submenu--is-open').attr('aria-expanded', 'true');

			if (moveFocusIntoSubmenu) {
				const $focusable = getFocusableElements($submenu);
				if ($focusable.length) {
					$focusable.first().focus();
				} else {
					$submenu.focus();
				}
			}

			// Recompute first and last focusable each time in case submenu changes
			const $allFocusable = getFocusableElements($submenu);
			const firstElem = $allFocusable.first()[0];
			const lastElem = $allFocusable.last()[0];

			// 1) If user presses Tab on last element → close and focus arrow
			$(lastElem).on('keydown.submenuTrap', function (e) {
				if (e.key === 'Tab' && !e.shiftKey) {
					e.preventDefault();
					toggleSubmenu(handle, $trigger, false);
					// Defer focus back to the arrow so browser doesn't override it
					setTimeout(() => {
						$triggerButton.focus();
					}, 0);
				}
			});

			// 2) If user presses Shift+Tab on first element → close and focus arrow
			$(firstElem).on('keydown.submenuTrap', function (e) {
				if (e.key === 'Tab' && e.shiftKey) {
					e.preventDefault();
					toggleSubmenu(handle, $trigger, false);
					setTimeout(() => {
						$triggerButton.focus();
					}, 0);
				}
			});

			// 3) If user presses Escape anywhere in document while submenu open → close and focus arrow
			$(document).on('keydown.submenuEscape', function (e) {
				if (e.key === 'Escape') {
					e.preventDefault();
					toggleSubmenu(handle, $trigger, false);
					setTimeout(() => {
						$triggerButton.focus();
					}, 0);
				}
			});
		}
	}

	function getFocusableElements($container, excludeSelector) {
		var $elements = $container
			.find(
				'a[href], button:not([disabled]), textarea, input:not([type="hidden"]):not([disabled]), select, [tabindex]:not([tabindex="-1"])',
			)
			.filter(':visible');

		if (excludeSelector) {
			$elements = $elements.not(excludeSelector);
		}

		return $elements;
	}

	// Manage tab key exit + Escape close
	function manageFocusExit($submenu, $triggerButton, $nextFocusTarget) {
		const $focusable = getFocusableElements($submenu);
		const last = $focusable.last()[0];

		$submenu.on('keydown.exitSubmenu', function (e) {
			// Exit to next menu item on Tab from last item
			if (e.key === 'Tab' && !e.shiftKey && document.activeElement === last) {
				e.preventDefault();
				if ($nextFocusTarget && $nextFocusTarget.length) {
					$nextFocusTarget.focus();
					toggleSubmenu($submenu.attr('data-handle'), $triggerButton, false);
				}
			}

			// Close on Escape
			if (e.key === 'Escape') {
				e.preventDefault();
				toggleSubmenu($submenu.attr('data-handle'), $triggerButton, false);
				$triggerButton.focus();
			}
		});
	}

	// Keydown handler on the toggle button to handle Enter, Space, and Tab
	$('.header-menu__button').on('keydown', function (e) {
		const $btn = $(this);
		const ariaControls = $btn.attr('aria-controls') || '';
		const handle = ariaControls.replace('submenu-', '').replace('-menu', '');

		if (!handle) return;

		// Reference to the submenu and trigger for reuse
		const $submenu = $('.site-nav__submenu[data-handle="' + handle + '"]');

		// Enter or Space toggles submenu, focusing inside if opened
		if (e.key === 'Enter' || e.key === ' ') {
			e.preventDefault();
			toggleSubmenu(handle, $btn, true); // true to move focus inside submenu
		}

		// Tab key: if submenu is open, move focus inside submenu
		if (e.key === 'Tab' && $submenu.hasClass('submenu--is-open')) {
			e.preventDefault();
			// Find first focusable element inside submenu
			const $firstFocusable = $submenu
				.find(
					'a, button, input, select, textarea, [tabindex]:not([tabindex="-1"])',
				)
				.filter(':visible')
				.first();

			if ($firstFocusable.length) {
				$firstFocusable.focus();
			} else {
				// If none found, focus submenu container itself
				$submenu.focus();
			}
		}
	});

	// To keep submenu open while focused (keyboard users)
	$('.site-nav__submenu').on('focusin', function () {
		hovered_over_menu = $(this).attr('data-handle');
	});

	// $('.site-nav__submenu').on('focusout', function() {
	//   const handle = $(this).attr('data-handle');
	//   setTimeout(() => {
	//     if (document.activeElement !== this) {
	//       hovered_over_menu = null;
	//       toggleSubmenu(handle, $(this), false);
	//     }
	//   }, 200);
	// });

	// set up header
	var menu_height = 0;
	$('#mobile-site-nav-list > li').each(function () {
		menu_height = menu_height + $(this).outerHeight();
	});
	if ($(window).height() - 56 > menu_height) {
		var top_padding = Math.ceil(($(window).height() - 56 - menu_height) / 2);
		$('#mobile-site-nav-list > li:first-child').css('paddingTop', top_padding);
	}

	function closeMobileMenu() {
		const $toggle = $('#mobile-hamburger-toggle');
		const $mobileMenu = $('#mobile-site-nav-list');
		const $dialog = $mobileMenu.find('.header__nav-wrapper[role="dialog"]');

		$mobileMenu.removeClass('show-menu');
		$toggle.removeClass('no-hamburgler');
		$toggle.attr('aria-expanded', 'false');
		$toggle.attr('aria-label', 'Open main menu');
		$toggle.find('.sr-only').text('Open main menu');
		$('body').css('overflow', '');

		if ($dialog.length) {
			removeTrapFocus($toggle[0]);
		}
	}

	$('#mobile-hamburger-toggle').click(function (e) {
		e.preventDefault();
		const $toggle = $(this);
		const $mobileMenu = $('#mobile-site-nav-list');
		const $dialog = $mobileMenu.closest(
			'div.z5[data-section-type="header-section"]',
		);

		if ($('#mini-cart').hasClass('is-open')) {
			$('#mini-cart').removeClass('is-open');
		}

		if ($mobileMenu.hasClass('show-menu')) {
			closeMobileMenu();
		} else {
			$mobileMenu.addClass('show-menu');
			$toggle.addClass('no-hamburgler');
			$toggle.attr('aria-expanded', 'true');
			$toggle.attr('aria-label', 'Close main menu');
			$toggle.find('.sr-only').text('Close main menu');
			$('body').css('overflow', 'hidden');

			if ($dialog.length) {
				const dialogElement = $dialog[0];
				const $firstFocusable = getFocusableElements(
					$dialog,
					'.site-nav.medium-down--hide, .site-nav.medium-down--hide *',
				).first();
				const firstFocusable = $firstFocusable.length
					? $firstFocusable[0]
					: null;
				trapFocus(
					dialogElement,
					firstFocusable || dialogElement,
					'.site-nav.medium-down--hide',
				);
			}
		}
	});

	$(document).on('keydown', function (e) {
		if (
			e.key === 'Escape' &&
			$('#mobile-site-nav-list').hasClass('show-menu')
		) {
			e.preventDefault();
			closeMobileMenu();
		}
	});

	$('a[rel="modal:open"]').click(function (event) {
		$(this).modal({
			fadeDuration: 250,
		});
		return false;
	});

	// set up product quantities
	$('input[type="number"][name="quantity"]').keyup(function () {
		if (parseInt($(this).val()) == 0) $(this).val('1');
		if (parseInt($(this).val()) > 9) $(this).val('9');
		$(this).val(
			$(this)
				.val()
				.match(/[0-9]*/),
		);
	});
	$('input[type="number"][name="quantity"]').blur(function () {
		if (parseInt($(this).val()) == 0 || $(this).val() == '') $(this).val('1');
		if (parseInt($(this).val()) > 9) $(this).val('9');
		$(this).val(
			$(this)
				.val()
				.match(/[0-9]*/),
		);
	});

	// faq page
	if ($('.faq-sidebar').length) {
		var lastId,
			topMenu = $('.faq-sidebar ul'),
			menuItems = topMenu.find('a'),
			scrollItems = menuItems.map(function () {
				var item = $($(this).attr('href'));
				if (item.length) {
					return item;
				}
			});

		// animate scroll to anchor
		menuItems.click(function (e) {
			e.preventDefault();
			var faq_section = $('div' + $(this).attr('href'));
			$('html,body').animate(
				{
					scrollTop:
						faq_section.offset().top -
						$('#shopify-section-header').height() -
						30,
				},
				'slow',
			);
			window.location.hash = $(this).attr('href');
		});

		// highlight selected menu item on scroll
		/*
    var sidebar_menu_top = $('#shopify-section-header').height() - $(window).scrollTop();
    if(sidebar_menu_top < 0) sidebar_menu_top = 0;
    $('.faq-sidebar').css('top', sidebar_menu_top);
    */
		$('.faq-sidebar').css('top', $('#shopify-section-header').height());
		var scrollBottom =
			$(document).height() - $(window).height() - $(window).scrollTop();
		var sidebar_menu_height_adjustment =
			$('#shopify-section-footer').outerHeight() - scrollBottom + 1;
		if (sidebar_menu_height_adjustment < 0) sidebar_menu_height_adjustment = 0;
		sidebar_menu_height_adjustment =
			sidebar_menu_height_adjustment +
			$('#shopify-section-header').height() +
			1;
		$('.faq-sidebar').css(
			'height',
			'calc(100vh - ' + sidebar_menu_height_adjustment + 'px)',
		);
		$(window).scroll(function (e) {
			var sidebar_menu_top =
				$('#shopify-section-header').height() - $(this).scrollTop();
			if (sidebar_menu_top < 0) sidebar_menu_top = 0;
			//$('.faq-sidebar').css('top', sidebar_menu_top);
			var scrollBottom =
				$(document).height() - $(window).height() - $(window).scrollTop();
			var sidebar_menu_height_adjustment =
				$('#shopify-section-footer').outerHeight() - scrollBottom + 1;
			if (sidebar_menu_height_adjustment < 0)
				sidebar_menu_height_adjustment = 0;
			sidebar_menu_height_adjustment =
				sidebar_menu_height_adjustment +
				$('#shopify-section-header').height() +
				1;
			$('.faq-sidebar').css(
				'height',
				'calc(100vh - ' + sidebar_menu_height_adjustment + 'px)',
			);

			var cur = scrollItems.map(function () {
				if (
					$(this).offset().top - $(window).height() + 50 <
					$(window).scrollTop()
				)
					return this;
			});
			cur = cur[cur.length - 1];
			var id = cur && cur.length ? cur[0].id : scrollItems[0].id;

			if (lastId !== id) {
				lastId = id;
				menuItems.removeClass('selected');
				menuItems.filter('[href="#' + id + '"]').addClass('selected');
			}
		});

		// toggle answer when icon is clicked
		$('.question .plus').click(function () {
			$('.answer').slideUp();
			$('.question .plus').show();
			$('.question .close').hide();
			$(this).closest('li').find('.answer').slideDown();
			$(this).hide();
			$(this).closest('li').find('.question .close').show();
		});
		$('.question h5').click(function () {
			if ($(this).closest('.question').find('.plus').is(':visible')) {
				$(this).closest('.question').find('.plus:visible').trigger('click');
			} else {
				$(this).closest('.question').find('.close:visible').trigger('click');
			}
		});
		$('.question .close').click(function () {
			$(this).closest('li').find('.answer').slideUp();
			$(this).hide();
			$(this).closest('li').find('.question .plus').show();
		});
	}

	// footer mailing list
	$('#footer-mailing-list').submit(function (e) {
		$(this).find('input[name="email"]').val();
		$(this)
			.find('input[type="submit"]')
			.attr('data-original-text', $(this).find('input[type="submit"]').val());
		$(this).find('input[type="submit"]').val('Subscribed!');
		setTimeout(function () {
			$('#footer-mailing-list')
				.find('input[type="submit"]')
				.val(
					$('#footer-mailing-list')
						.find('input[type="submit"]')
						.attr('data-original-text'),
				);
		}, 1000);
	});

	var sections = new slate.Sections();
	sections.register('product', theme.Product);

	// Common a11y fixes
	slate.a11y.pageLinkFocus($(window.location.hash));

	$('.in-page-link').on('click', function (evt) {
		slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
	});

	// Wrap videos in div to force responsive layout.
	slate.rte.wrapTable();
	slate.rte.iframeReset();

	// Apply a specific class to the html element for browser support of cookies.
	if (slate.cart.cookiesEnabled()) {
		document.documentElement.className =
			document.documentElement.className.replace(
				'supports-no-cookies',
				'supports-cookies',
			);
	}

	// cart things
	slate.cart.initCart();

	// preload images
	$('.product-image img').each(function () {
		var i = new Image();
		i.src = $(this).attr('src');
	});

	$('.product-image').swipe({
		//Generic swipe handler for all directions
		swipe: function (
			e,
			direction,
			distance,
			duration,
			fingerCount,
			finterData,
		) {
			if (direction == 'right') {
				if ($('.product-image-pagination > a.selected').prev().length > 0) {
					$('.product-image-pagination > a.selected')
						.prev()
						.trigger('click', ['right', 500]);
				} else {
					$('.product-image-pagination > a:last').trigger('click', [
						'right',
						500,
					]);
				}
			} else {
				if ($('.product-image-pagination > a.selected').next().length > 0) {
					$('.product-image-pagination > a.selected')
						.next()
						.trigger('click', ['left', 500]);
				} else {
					$('.product-image-pagination > a:first').trigger('click', [
						'left',
						500,
					]);
				}
			}
		},
		//Default is 75px, set to 0 for demo so any distance triggers swipe
		threshold: 10,
	});

	$('.product-image-pagination > a').on(
		'click',
		function (e, direction, timing) {
			e.preventDefault();

			if (timing == undefined) timing = 500;

			$visibleImage = $(this)
				.closest('.product-image')
				.find('img:visible')
				.first();
			$clickedImage = $(this)
				.closest('.product-image')
				.find(
					'#product-image-' +
						($(this).closest('.product-image').find('a').index($(this)) + 1),
				);
			if (direction == 'right') {
				$visibleImage.hide('fade', {}, timing);
				$clickedImage.show('fade', {}, timing);
			} else {
				$visibleImage.hide('fade', {}, timing);
				$clickedImage.show('fade', {}, timing);
			}

			$('.product-image-pagination > a').removeClass('selected');
			$(this).addClass('selected');
		},
	);

	/* start seasonal */
	$('.seasonal .variant-selector a').click(function () {
		$('.variant-selector li').addClass('inactive');
		$(this).closest('li').removeClass('inactive');
		$(
			'.product-image-pagination > a[data-variant-id="' +
				$(this).closest('li').attr('data-variant-id') +
				'"]',
		).trigger('click');
		$(
			'.variant-price[data-variant-id!="' +
				$(this).closest('li').attr('data-variant-id') +
				'"]',
		).hide();
		$(
			'.variant-price[data-variant-id="' +
				$(this).closest('li').attr('data-variant-id') +
				'"]',
		).show();
		if ($(this).closest('li').attr('data-variant-id') == 'the-threesome') {
			$('.specs').hide();
			$('.variant-title').show();
			$('.variant-descriptors').show();
			window.history.pushState('variant', 'Variant', '?');
		} else {
			$('.specs').hide();
			$(
				'.variant-title[data-variant-id!="' +
					$(this).closest('li').attr('data-variant-id') +
					'"]',
			).hide();
			$(
				'.variant-title[data-variant-id="' +
					$(this).closest('li').attr('data-variant-id') +
					'"]',
			).show();
			$(
				'.variant-descriptors[data-variant-id!="' +
					$(this).closest('li').attr('data-variant-id') +
					'"]',
			).hide();
			$(
				'.variant-descriptors[data-variant-id="' +
					$(this).closest('li').attr('data-variant-id') +
					'"]',
			).show();
			// Persistent UTM & Tracking Fix
			var original_search_params = new URLSearchParams(window.location.search);
			var params_obj = Object.fromEntries(original_search_params.entries());
			delete params_obj['variant'];
			const newQueryString = new URLSearchParams(params_obj).toString();
			window.history.pushState(
				'variant',
				'Variant',
				'?variant=' +
					$(this).closest('li').attr('data-variant-id') +
					`${newQueryString && `&${newQueryString}`}`,
			);

			$('.add-to-cart-container').show();

			if ($(this).closest('li').attr('data-available') == 'false') {
				$('#add_to_cart_container_top')
					.find('button')
					.addClass('disabled')
					.prop('disabled', 'disabled');
				$('#add_to_cart_container_top').find('button > span').text('Sold Out');
				$('#global_quantity').addClass('disabled').prop('disabled', 'disabled');
				$('.seasonal [data-add-to-cart-seasonal]').prop('disabled', 'disabled');
			} else {
				$('#global_quantity').removeClass('disabled').removeProp('disabled');
				$('#add_to_cart_container_top')
					.find('button')
					.removeClass('disabled')
					.removeProp('disabled');
				$('#add_to_cart_container_top')
					.find('button > span')
					.text('Add To Cart');
				$('.seasonal [data-add-to-cart-seasonal]').prop('disabled', false);
			}
		}
	});

	// check URL to see if there was a variant specified - if not, select the threesome
	var selected_variant = getURLParameter('variant');
	if (selected_variant) {
		$(
			'.seasonal .variant-selector li[data-variant-id="' +
				selected_variant +
				'"] a',
		).trigger('click');
	}
	// } else {
	//   $('.seasonal .variant-selector li:first a').trigger('click');
	// }

	$('.seasonal [data-add-to-cart-seasonal]').click(function () {
		//console.log('hey add', variant_id)
		var variant_id = $('.variant-selector li:not(.inactive)')
			.first()
			.attr('data-variant-id');
		$('#add-form-' + variant_id + ' input[name="quantity"]').val(
			$('#global_quantity').val(),
		);
		$('#add-form-' + variant_id).trigger('submit');
	});

	$('[data-add-product]').click(function (e) {
		e.preventDefault();
		$(this).closest('.promos').find('#add-form').trigger('submit');
	});
	/* end seasonal */

	/* Buy Bundles */
	$('[data-buy-bundle], [data-buy-all]').each(function () {
		var $addForm = $(this).find('#add-form');

		//If no form is found on context of a bundle block, find on page
		if ($addForm.length === 0) {
			$addForm = $('#add-form');
		}

		var $bundle = $(this);
		var $giftForm = $(this).find('.promo-gift-form');
		var $promo = $(this).find('.promo-block');
		var $backBtn = $(this).find('.promo-back-btn');
		var $continueBtn = $(this).find('#bundle-gift-continue-btn');
		var $skipNoteBtn = $(this).find('#bundle-skip-note-btn');
		var $orderNote = $(this).find('#add-form #order_note');
		var $recipient = $(this).find('[name="properties[Recipient]"]');
		var $message = $(this).find('[name="properties[Message]"]');
		var $signature = $(this).find('[name="properties[Signature]"]');
		var $giftName = $(this).find('#gift_name');
		var $giftGiver = $(this).find('#gift_giver');
		var $giftMessage = $(this).find('#gift_message');
		var $candleOneVariantID = $(this).find('#add-form #candle_1_variant_id');
		var $candleTwoVariantID = $(this).find('#add-form #candle_2_variant_id');
		var $candleThreeVariantID = $(this).find('#add-form #candle_3_variant_id');
		var $matchboxID = $(this).find('#add-form [data-matchbox]').last();
		var $customizeBtn = $(this).find('[data-customize]');
		var $addToCartBtn = $(this).find('[data-add-to-cart]');

		$customizeBtn.on('click', function (e) {
			e.stopPropagation();
		});

		$(this).unbind('submit');

		$backBtn.on('click', function (e) {
			$giftForm.hide();
			e.preventDefault();
			$('body').removeClass('pin-body');
			$('#gift_name, #gift_message, #gift_giver').val('');
			$('[data-gift-chars-left]').each(function () {
				$(this).text($(this).attr('data-max'));
			});
			return false;
		});

		$giftForm.on('click', function (e) {
			if (e.target === $giftForm[0]) {
				$giftForm.hide();
				e.preventDefault();
				$('body').removeClass('pin-body');
				$('#gift_name, #gift_message, #gift_giver').val('');
				$('[data-gift-chars-left]').each(function () {
					$(this).text($(this).attr('data-max'));
				});
				return false;
			}
		});

		$continueBtn.on('click', function (e) {
			e.preventDefault();
			$orderNote.val(
				$matchboxID.val() +
					'}}' +
					$giftName.val() +
					'}}' +
					$giftMessage.val() +
					'}}' +
					$giftGiver.val() +
					'}}' +
					$candleOneVariantID.val() +
					'}}' +
					$candleTwoVariantID.val() +
					'}}' +
					$candleThreeVariantID.val(),
			);
			console.log($orderNote.val());
			$addForm.trigger('submit');
		});

		$skipNoteBtn.on('click', function (e) {
			$orderNote.val('');
			$recipient.val('');
			$message.val('');
			$signature.val('');
			console.log($orderNote.val());
			$addForm.trigger('submit');
		});

		$addToCartBtn.on('click', function () {
			if ($(this)[0].hasAttribute('data-is-gift')) {
				$giftForm.show();
				$('body').addClass('pin-body');
			} else {
				$addForm.trigger('submit');
			}
		});
	});

	/* Buy all (3 or 6) - PDP */
	$('[data-buy-all]').each(function () {
		var sixPack = $('#add-form-the-six-pack, #add-form-the-three-pack');

		$(this).on('click', function () {
			sixPack.trigger('submit');
		});
	});

	$('.advert').click(function () {
		$(this).find('a').first()[0].click();
	});
});

$(window).on('load', function () {
	$('#shopify-section-featured-collection,.candle-collection-display').each(
		function () {
			var scroll_cutoff =
				($(this).find('ul')[0].scrollWidth - $(window).width()) / 2;
			$(this).find('ul').scrollLeft(scroll_cutoff);
		},
	);
	$('.fade-me-in').each(function () {
		if ($(this).hasClass('asap')) {
			var addition = 100;
		} else {
			var addition = $(this).height() / 5;
		}
		if (
			$(window).scrollTop() + $(window).height() >
			$(this).offset().top + addition
		) {
			if ($(this).attr('data-fade-in')) {
				var timeout = parseInt($(this).attr('data-fade-in'));
			} else {
				var timeout = 0;
			}
			$(this).addClass('invisible').removeClass('fade-me-in');
			setTimeout(
				function () {
					$(this).addClass('fade-in').removeClass('invisible');
				}.bind(this),
				timeout,
			);
		}
	});
	$('.fade-me-out').each(function () {
		if ($(this).attr('data-fade-out')) {
			var timeout = parseInt($(this).attr('data-fade-out'));
		} else {
			var timeout = 0;
		}
		setTimeout(
			function () {
				$(this).addClass('invisible').removeClass('fade-me-out');
			}.bind(this),
			timeout,
		);
	});
});

// Fade-in observer
const fadeInObserver = new IntersectionObserver(
	(entries, observer) => {
		entries.forEach((entry) => {
			if (entry.isIntersecting) {
				const $el = $(entry.target);
				const timeout = parseInt($el.attr('data-fade-in')) || 0;

				$el.addClass('invisible'); // optional: prepare state before fade-in

				setTimeout(() => {
					$el.addClass('fade-in').removeClass('invisible fade-me-in');
				}, timeout);

				observer.unobserve(entry.target); // prevent repeat
			}
		});
	},
	{
		threshold: 0.1, // trigger when 10% of the element is in view
	},
);

// Apply observer to existing .fade-me-in elements
$('.fade-me-in').each(function () {
	fadeInObserver.observe(this);
});

function resizePromoBar() {
	let mql = window.matchMedia('(min-width: 800px)');
	if (mql.matches) {
		$('#promo-bar').height('100px');
	} else {
		$('#promo-bar').height('70px');
	}
}

resizePromoBar();
setBodyPadding();

$(window).on('resize', function () {
	resizePromoBar();
	setBodyPadding();
});

function setBodyPadding() {
	$('#shopify-section-header div#mini-cart').css(
		'top',
		getMiniCartTop() + 'px',
	);
	var promoBarHeight = $('#promo-bar').height()
		? parseInt($('#promo-bar').height())
		: 0;
	var topBarHeight = $('#top-bar').height()
		? parseInt($('#top-bar').height())
		: 0;
	var headerHeight = $('header[role=banner]').height()
		? parseInt($('header[role=banner]').height())
		: 0;
	//var padding = topBarHeight + promoBarHeight + headerHeight;
	var padding = topBarHeight + headerHeight;
	$('body').css('paddingTop', padding + 'px');

	//$('#shopify-section-header #mobile-site-nav-list').css('top', 139 + topBarHeight + 'px');
	//$('#shopify-section-header #mobile-site-nav-list').css('top', 193 + topBarHeight + 'px');
	//$('#shopify-section-header ul.site-nav__submenu').css('top', 134 + topBarHeight + 'px');
	$('#shopify-section-header div#mini-cart').css(
		'top',
		getMiniCartTop() + 'px',
	);
	$('.sticky-container').css('top', 20 + padding + 'px');
}

function getURLParameter(name) {
	return (
		decodeURIComponent(
			(new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(
				location.search,
			) || [null, ''])[1].replace(/\+/g, '%20'),
		) || null
	);
}

function getMiniCartTop() {
	var mq = window.matchMedia('(min-width: 990px)');
	var promoBarHeight = $('#promo-bar').height()
		? parseInt($('#promo-bar').height())
		: 0;
	var topBarHeight = $('#top-bar').height()
		? parseInt($('#top-bar').height())
		: 0;
	var scrollTop = $(window).scrollTop();
	var offset = mq.matches ? 100 : 65;

	//if(scrollTop < promoBarHeight + topBarHeight) {
	if (scrollTop < topBarHeight) {
		//var minicart_top = offset + promoBarHeight + topBarHeight - scrollTop;
		var minicart_top = offset + topBarHeight - scrollTop;
	} else {
		var minicart_top = offset + topBarHeight;
	}

	return minicart_top;
}

/*jQuery(document).ready(function(){
  var $clock = jQuery('.promo-countdown'),
      $productCountdown = jQuery('.product-countdown'),
      eventTime = moment('30-11-2023 03:00:00', 'DD-MM-YYYY HH:mm:ss').unix(),
      currentTime = moment().unix(),
      diffTime = eventTime - currentTime,

      duration = moment.duration(diffTime * 1000, 'milliseconds'),
      interval = 1000;

  // if time to countdown
  if(diffTime > 0) {
      $clock.show();
      var $d = jQuery('.countdown-days__val span'),
          $h = jQuery('.countdown-hrs__val span'),
          $m = jQuery('.countdown-mins__val span'),
          $s = jQuery('.countdown-secs__val span');

      $clock.css({'display': 'flex'});
      calcTime();

      setInterval(function(){
        calcTime();
      }, interval);
  } else {
    $clock.hide();
    $productCountdown.hide();
  }

  function calcTime() {
    duration = moment.duration(duration.asMilliseconds() - interval, 'milliseconds');
    var d = moment.duration(duration).days(),
        h = moment.duration(duration).hours(),
        m = moment.duration(duration).minutes(),
        s = moment.duration(duration).seconds();

    
    // if(parseInt(d) > 0){
    //   $('.days, .days-sep').show();
    // }

    d = jQuery.trim(d).length === 1 ? '0' + d : d;
    h = jQuery.trim(h).length === 1 ? '0' + h : h;
    m = jQuery.trim(m).length === 1 ? '0' + m : m;
    s = jQuery.trim(s).length === 1 ? '0' + s : s;

    // show how many hours, minutes and seconds are left
    $d.html(d);
    $h.html(parseInt(h) + parseInt(d * 24));
    $m.html(m);
    $s.html(s);
  }
});*/

jQuery(document).ready(function ($) {
	$('.section-bundles').each(function () {
		var $title = $(this).find('.section-bundles__title').first().html();
		$('.bundle-filters').append(
			'<a class="btn chronicle-semi btn-small" href="#" data-filter-bundles="' +
				$title.toLowerCase() +
				'">' +
				$title +
				'</a>',
		);
	});

	var $bundleFilters = $('.bundle-filters a');
	var $sectionBundles = $('.section-bundles[data-bundle]');

	$bundleFilters.on('click', function (e) {
		e.preventDefault();
		$bundleFilters.removeClass('active');
		$(this).addClass('active');
		// $(this).append('<span class="national-book"><svg width="20" height="20" viewBox="0 0 20 20" class="icon"><path fill="currentColor" d="M15.89 14.696l-4.734-4.734 4.717-4.717c.4-.4.37-1.085-.03-1.485s-1.085-.43-1.485-.03L9.641 8.447 4.97 3.776c-.4-.4-1.085-.37-1.485.03s-.43 1.085-.03 1.485l4.671 4.671-4.688 4.688c-.4.4-.37 1.085.03 1.485s1.085.43 1.485.03l4.688-4.687 4.734 4.734c.4.4 1.085.37 1.485-.03s.43-1.085.03-1.485z"></path></svg></span>');
		$filter = $(this).attr('data-filter-bundles');
		console.log(
			$('.section-bundles[data-bundle="' + $filter.toLowerCase() + '"]'),
		);
		if ($filter === 'all') {
			$sectionBundles.show();
		} else {
			$sectionBundles.hide();
			$('.section-bundles[data-bundle="' + $filter.toLowerCase() + '"]').show();
		}
	});
});

// PDP

function showHideStickyCart(entries, observer) {
	let entry = entries[0];
	if (entry.intersectionRatio >= 1) {
		entry.target.classList.remove('product__sticky--show');
	} else if (entry.intersectionRatio <= 0 && entry.boundingClientRect.y <= 0) {
		entry.target.classList.add('product__sticky--show');
		entry.target.classList.remove('product__sticky--hide');
	} else {
		entry.target.classList.add('product__sticky--hide');
	}
}

function initStickyCart() {
	const options = {
		rootMargin: '100px 0px 0px 0px',
		threshold: [0, 0.01, 1],
	};

	const target = document.querySelector('#productStickyContainer');

	if (target) {
		const observer = new IntersectionObserver(showHideStickyCart, options);
		observer.observe(target);
	} else {
		console.warn('#productStickyContainer not found');
	}
}

const selectors = {
	productThumbnailsSlider: 'carousel--product-thumbnails',
	productFeatureSlider: 'carousel--featured-product',
};

function initProductCarousel() {
	const self = this;

	// Thumbnail swiper
	const productThumbnailSwiper = new Swiper(
		`.${selectors.productThumbnailsSlider}`,
		{
			slidesPerView: 4,
			freeMode: true,
			watchSlidesVisibility: true,
			watchSlidesProgress: true,
			navigation: true,
			a11y: {
				enabled: true,
			},
			breakpoints: {
				680: {
					slidesPerView: 7,
					spaceBetween: 10,
				},
			},
			on: {
				afterInit: function () {
					const productThumbnailItems = document.querySelectorAll(
						'.product__thumbnail-item',
					);
					productThumbnailItems.forEach((item) => {
						item.removeAttribute('role');
						item.removeAttribute('aria-label');
						item.setAttribute(
							'aria-label',
							'Go to slide ' + (Number(item.getAttribute('data-index')) + 1),
						);
					});
				},
			},
		},
	);

	// Featured swiper
	const productFeatureSwiper = new Swiper(
		`.${selectors.productFeatureSlider}`,
		{
			spaceBetween: 0,
			slidesPerView: 1,
			a11y: {
				enabled: true,
			},
			navigation: {
				nextEl: '.swiper-button-next-product',
				prevEl: '.swiper-button-prev-product',
			},
			thumbs: {
				swiper: productThumbnailSwiper,
			},
			on: {
				slideChange: function () {
					// Get the current active slide, and update aria-hidden for the current and others
					const currentSlide =
						productFeatureSwiper.slides[productFeatureSwiper.activeIndex];
					const otherSlides = productFeatureSwiper.slides.filter(
						(slide) => slide !== currentSlide,
					);
					currentSlide.setAttribute('aria-hidden', 'false');
					otherSlides.forEach((slide) =>
						slide.setAttribute('aria-hidden', 'true'),
					);
				},
			},
		},
	);

	// Keyboard navigation for feature swiper slides
	productFeatureSwiper.slides.forEach((slide, index) => {
		slide.addEventListener('keydown', (e) => {
			if (e.key === 'Escape') {
				productThumbnailSwiper.slides.forEach((tslide) =>
					tslide.setAttribute('tabindex', '0'),
				);
				productThumbnailSwiper.slides[index].focus();
			}
		});
	});

	// Keyboard & focus handling for thumbnails
	productThumbnailSwiper.slides.forEach((slide, index) => {
		const thumbnailDiv = slide.querySelector('[data-product-single-thumbnail]');

		if (thumbnailDiv) {
			// Handle keyboard events on the thumbnail div (Enter and Space)
			thumbnailDiv.addEventListener('keydown', (e) => {
				if (e.key === 'Enter' || e.key === ' ') {
					e.preventDefault();
					// Trigger click to change the featured image
					thumbnailDiv.click();
				}
			});

			// Handle focus on the thumbnail div
			thumbnailDiv.addEventListener('focus', () => {
				productThumbnailSwiper.slideTo(index, true);
				productFeatureSwiper.slideTo(index, true);
				productThumbnailSwiper.slides.forEach((tslide) => {
					const thumb = tslide.querySelector('[data-product-single-thumbnail]');
					if (thumb) thumb.setAttribute('tabindex', '0');
				});
			});
		}

		// Keep existing slide-level keyboard handling for Enter key
		slide.addEventListener('keydown', (e) => {
			if (e.key === 'Enter') {
				productThumbnailSwiper.slides.forEach((tslide) => {
					const thumb = tslide.querySelector('[data-product-single-thumbnail]');
					if (thumb) thumb.setAttribute('tabindex', '-1');
				});
				if (thumbnailDiv) {
					thumbnailDiv.setAttribute('tabindex', '0');
					productFeatureSwiper.slides[index].focus();
				}
			}
		});
	});

	// Sync navigation buttons click (optional)
	const nextBtn = document.querySelector(selectors.nextBtn);
	const prevBtn = document.querySelector(selectors.prevBtn);

	nextBtn?.addEventListener('click', () => {
		let idx = productThumbnailSwiper.activeIndex;
		productThumbnailSwiper.slideTo(idx, true);
		productFeatureSwiper.slideTo(idx, true);
	});
	prevBtn?.addEventListener('click', () => {
		let idx = productThumbnailSwiper.activeIndex;
		productThumbnailSwiper.slideTo(idx, true);
		productFeatureSwiper.slideTo(idx, true);
	});

	// Store on global selectors (optional)
	selectors.productSwiperThumbs = productThumbnailSwiper;
	selectors.productSwiperFeature = productFeatureSwiper;
}

document.addEventListener('DOMContentLoaded', () => {
	initProductCarousel();
	initStickyCart();
});

document.querySelectorAll('.quantity-wrapper').forEach((wrapper) => {
	const input = wrapper.querySelector('.qty-input');
	const minus = wrapper.querySelector('.minus');
	const plus = wrapper.querySelector('.plus');

	minus.addEventListener('click', (e) => {
		e.preventDefault(); // stop default action
		let value = parseInt(input.value, 10);
		if (!isNaN(value) && value > 1) {
			input.value = value - 1;
			input.dispatchEvent(new Event('change')); // trigger if cart updates live
		}
	});

	plus.addEventListener('click', (e) => {
		e.preventDefault(); // stop default action
		let value = parseInt(input.value, 10);
		if (!isNaN(value)) {
			input.value = value + 1;
			input.dispatchEvent(new Event('change')); // trigger if cart updates live
		}
	});
});

// CONTENT PANEL VIDEO

// -------------------------------------
// Class Constants
// -------------------------------------

const MODAL_OPEN_BUTTON = '.modal__trigger';
const MODAL_CLOSE_BUTTON = '.modal__close-button';
const MODAL_OVERLAY = '.modal__overlay';
const MODAL_CONTENT = '.modal__popup .modal__content';

const OPEN_CLASS_MODAL = 'modal--open';
const NO_SCROLL_CLASS_MODAL = 'noscroll';

// Keep a map of Vimeo Player instances keyed by modal id
const vimeoPlayers = {};

// -------------------------------------
// Functions
// -------------------------------------

const openModal = (modal) => {
	const closeButton = modal.querySelector('.modal__close-button');
	modal.classList.add(OPEN_CLASS_MODAL);
	document.body.classList.add(NO_SCROLL_CLASS_MODAL);

	modal
		.querySelectorAll('[tabindex="-1"]')
		.forEach((el) => el.setAttribute('tabindex', '0'));
	closeButton.focus();

	// Check if there's at least one <video> and play it
	const videos = modal.querySelectorAll('video');
	if (videos.length > 0) {
		videos.forEach((video) => {
			// Only play if it's paused
			if (video.paused) {
				video.play().catch(() => {
					// Handle autoplay restrictions silently
				});
			}
		});
	}

	const modalEvent = new CustomEvent('open.modal', { detail: modal });
	window.dispatchEvent(modalEvent);
};

const closeModal = () => {
	const modal = document.querySelector('.modal--open');
	if (!modal) return;

	const modalId = modal.id.replace('modal_', '');
	const modalTrigger = document.querySelector(
		`[data-modal-target="${modalId}"]`,
	);

	// Check if there's at least one <video> inside the modal
	const videos = modal.querySelectorAll('video');
	if (videos.length > 0) {
		videos.forEach((video) => {
			video.pause();
			video.currentTime = 0;
		});
	}

	modal.classList.remove(OPEN_CLASS_MODAL);
	modal
		.querySelectorAll('[tabindex="0"]')
		.forEach((el) => el.setAttribute('tabindex', '-1'));

	const modalEvent = new CustomEvent('close.modal', { detail: modal });
	window.dispatchEvent(modalEvent);

	modalTrigger?.focus();
	document.body.classList.remove(NO_SCROLL_CLASS_MODAL);
};

const triggerModal = (event) => {
	const modalId = event.currentTarget.dataset.modalTarget;
	const modal = document.querySelector(`#modal_${modalId}`);
	const modalContent = modal.querySelector(MODAL_CONTENT);

	const focusableElements = modalContent.querySelectorAll(
		'[tabindex]:not([tabindex="-1"]), [href], button, input, iframe',
	);
	const firstFocusableElement = focusableElements[0];
	const lastFocusableElement = focusableElements[focusableElements.length - 1];

	// Setup keyboard trap for focus inside modal
	const handleKeydown = (e) => {
		if (e.key !== 'Tab') return;

		if (e.shiftKey) {
			if (document.activeElement === firstFocusableElement) {
				e.preventDefault();
				lastFocusableElement.focus();
			}
		} else {
			if (document.activeElement === lastFocusableElement) {
				e.preventDefault();
				firstFocusableElement.focus();
			}
		}
	};

	// Remove previous keydown listener if any
	document.removeEventListener('keydown', handleKeydown);
	document.addEventListener('keydown', handleKeydown);

	openModal(modal);
};

// -------------------------------------
// Event Bindings
// -------------------------------------

document.addEventListener('DOMContentLoaded', () => {
	document.querySelectorAll(MODAL_OPEN_BUTTON).forEach((openButton) => {
		openButton.addEventListener('click', triggerModal);
		openButton.addEventListener('keypress', (e) => {
			if (e.key === 'Enter') {
				triggerModal(e);
			}
		});
	});

	document.querySelectorAll(MODAL_CLOSE_BUTTON).forEach((closeButton) => {
		closeButton.addEventListener('click', closeModal);
	});

	document.querySelector(MODAL_OVERLAY)?.addEventListener('click', closeModal);
});

document.addEventListener('keydown', (event) => {
	if (event.key === 'Escape') {
		closeModal();
	}
});

// -------------------------------------
// Vimeo Player Integration (using CDN Vimeo Player SDK)
// -------------------------------------

window.addEventListener('open.modal', (event) => {
	const modal = event.detail;
	const modalContent = modal.querySelector(MODAL_CONTENT);
	const videoBlock = modalContent.querySelector(VIDEO_BLOCK);
	const videoElement = videoBlock?.querySelector(VIDEO);

	if (videoElement) {
		const modalId = modal.id;

		// Initialize Vimeo Player if not already
		if (!vimeoPlayers[modalId]) {
			vimeoPlayers[modalId] = new Vimeo.Player(videoElement);
		}

		vimeoPlayers[modalId].play().catch((error) => {
			console.warn('Error playing Vimeo video:', error);
		});
	}
});

window.addEventListener('close.modal', (event) => {
	const modal = event.detail;
	const modalContent = modal.querySelector(MODAL_CONTENT);
	const videoBlock = modalContent.querySelector(VIDEO_BLOCK);
	const videoElement = videoBlock?.querySelector(VIDEO);

	if (videoElement) {
		const modalId = modal.id;
		if (vimeoPlayers[modalId]) {
			vimeoPlayers[modalId].pause().catch((error) => {
				console.warn('Error pausing Vimeo video:', error);
			});
		}
	}
});

// -------------------------------------
// Variables
// -------------------------------------

// Selectors
const VIDEO_BLOCK = '.video-block';
const VIDEO = '.video-block__video';
const YOUTUBE_VIDEO = '.video-block--youtube';
const VIMEO_VIDEO = '.video-block--vimeo';
const HTML5_VIDEO = '.video-block--html5';
const CONTROLS_PLAY = '.video-block__control--play';
const CONTROLS_PAUSE = '.video-block__control--pause';

// Classes
const POSTERED_CLASS = 'video-block--is-postered';
const PAUSED_CLASS = 'video-block--is-paused';
const DYNAMIC_VIDEO_CLASS = 'video-block--dynamic-video';

// Events
const playerPlay = new Event('onplay.video-block');
const playerPause = new Event('onpause.video-block');
const play = new Event('play.video-block');
const pause = new Event('pause.video-block');

// -------------------------------------
// Helpers
// -------------------------------------

const videoBlocks = {
	init: function () {
		const videoBlockElems = document.querySelectorAll(VIDEO_BLOCK);

		videoBlockElems.forEach(function (videoBlock) {
			videoBlocks.initVideoBlock(videoBlock);
		});
	},
	initVideoBlock: function (videoBlock) {
		videoBlock.playButton = videoBlock.querySelector(CONTROLS_PLAY);
		videoBlock.pauseButton = videoBlock.querySelector(CONTROLS_PAUSE);
		videoBlock.querySelector(VIDEO).setAttribute('inert', '');

		videoBlock.addEventListener('onplay.video-block', function () {
			videoBlockControls.play(videoBlock);
		});

		videoBlock.addEventListener('onpause.video-block', function () {
			videoBlockControls.pause(videoBlock);
		});

		if (videoBlock.playButton !== null) {
			videoBlock.playButton.addEventListener('click', function () {
				videoBlockControls.play(videoBlock);
				videoBlock.dispatchEvent(play);
				videoBlock.pauseButton?.focus();
				videoBlock.querySelector(VIDEO).removeAttribute('inert');
			});
		}

		if (videoBlock.pauseButton !== null) {
			videoBlock.pauseButton.addEventListener('click', function () {
				videoBlockControls.pause(videoBlock);
				videoBlock.dispatchEvent(pause);
				videoBlock.playButton?.focus();
				videoBlock.querySelector(VIDEO).setAttribute('inert', '');
			});
		}
	},
};

const videoBlockControls = {
	play: function (videoBlock) {
		videoBlock.classList.remove(POSTERED_CLASS);
		videoBlock.classList.remove(PAUSED_CLASS);
	},
	pause: function (videoBlock) {
		videoBlock.classList.add(POSTERED_CLASS);
		videoBlock.classList.add(PAUSED_CLASS);
	},
};

const youtubeVideos = {
	init: function () {
		const tag = document.createElement('script');
		const firstScriptTag = document.getElementsByTagName('script')[0];

		tag.src = 'https://www.youtube.com/iframe_api';
		firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

		window.onYouTubeIframeAPIReady = function () {
			youtubeVideos.initVideos();
		};
	},
	initVideos: function () {
		const videoBlocks = document.querySelectorAll(YOUTUBE_VIDEO);

		videoBlocks.forEach(function (videoBlock) {
			const video = youtubeVideos.getVideo(videoBlock);
			const videoIframe = document.createElement('div');
			const videoSettings = JSON.parse(video.dataset.videoSettings);
			const videoID = videoSettings.video_id;
			video.appendChild(videoIframe);

			const player = new YT.Player(videoIframe, {
				videoId: videoID,
				playerVars: {
					playlist:
						videoSettings.playlist_id == null && videoSettings.is_looped
							? videoID
							: null,
					loop: videoSettings.is_looped ? 1 : 0,
					autoplay: videoSettings.is_autoplay ? 1 : 0,
					controls: videoSettings.is_controls ? 1 : 0,
					disablekb: videoSettings.is_controls ? 0 : 1,
					playsinline: videoSettings.is_autoplay ? 1 : 0,
					showinfo: 0,
					modestbranding: 1,
					fs: 1,
					cc_load_policy: 0,
					iv_load_policy: 3,
					rel: 0,
				},
				events: {
					onReady: youtubeVideos.onPlayerReady,
				},
			});
		});
	},
	onPlayerReady: function (event) {
		const player = event.target;
		const video = youtubeVideos.getVideo(
			player.getIframe().closest(VIDEO_BLOCK),
		);
		const videoBlock = video.closest(VIDEO_BLOCK);
		const videoSettings = video.dataset.videoSettings;

		player.setVolume(videoSettings.is_muted ? 0 : 100);

		videoBlock.addEventListener('play.video-block', function () {
			youtubeVideos.play(player);
		});

		videoBlock.addEventListener('pause.video-block', function () {
			youtubeVideos.pause(player);
		});

		player.getIframe.tabIndex = -1;
	},
	play: function (player) {
		const iframe = player.getIframe();

		iframe.tabIndex = 0;
		player.playVideo();
	},
	pause: function (player) {
		player.pauseVideo();
	},
	getVideo: function (videoBlock) {
		return videoBlock.querySelector(VIDEO);
	},
};

const vimeoVideos = {
	init: function () {
		const videoBlocks = document.querySelectorAll(VIMEO_VIDEO);

		videoBlocks.forEach(function (videoBlock) {
			const video = videoBlock.querySelector(VIDEO);
			const videoSettings = JSON.parse(video.dataset.videoSettings);
			const videoID = videoSettings.video_id;

			if (videoSettings.lookup_poster) {
				const url = 'https://vimeo.com/api/v2/video/' + videoID + '.json';

				fetch(url)
					.then((response) => response.json())
					.then((data) => {
						videoBlock.classList.add(POSTERED_CLASS);
						videoBlock.style.backgroundImage =
							'linear-gradient(rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)), url(' +
							data[0].thumbnail_large +
							')';
					})
					.catch((error) => {
						videoBlock.classList.remove(POSTERED_CLASS);
						videoBlock.style.backgroundImage = '';
					});
			}

			const player = new Vimeo(video, {
				id: videoID,
				loop: videoSettings.is_looped,
				autoplay: videoSettings.is_autoplay,
				autopause: !videoSettings.is_autoplay,
				title: false,
				portrait: false,
				byline: false,
				controls: videoSettings.is_controls,
			});

			player.setVolume(videoSettings.is_muted ? 0 : 1);

			videoBlock.addEventListener('play.video-block', function () {
				vimeoVideos.play(player);
			});

			videoBlock.addEventListener('pause.video-block', function () {
				vimeoVideos.pause(player);
			});
		});
	},
	play: function (player) {
		player.play();
	},
	pause: function (player) {
		player.pause();
	},
};

const html5Videos = {
	init: function () {
		const videoBlocks = document.querySelectorAll(HTML5_VIDEO);

		videoBlocks.forEach(function (videoBlock) {
			const video = videoBlock.querySelector(VIDEO);

			// If this video block has dynamic videos on mobile and desktop, get the appropriate video sources on mobile/desktop
			if (videoBlock.classList.contains(DYNAMIC_VIDEO_CLASS)) {
				const videoSources = JSON.parse(video.dataset.videoSources);
				const desktopVideoUrls =
					videoSources.desktop_video_source_urls.split(',');
				const desktopVideoSourceTypes =
					videoSources.desktop_video_source_types.split(',');
				const mobileVideoUrls =
					videoSources.mobile_video_source_urls.split(',');
				const mobileVideoSourceTypes =
					videoSources.mobile_video_source_types.split(',');
				let sourceUrls;
				let sourceTypes;

				if (window.innerWidth > 680 || mobileVideoUrls[0] == '') {
					// Load desktop videos. Fallback to Desktop videos if there is no mobile video uploaded
					sourceUrls = desktopVideoUrls;
					sourceTypes = desktopVideoSourceTypes;
				} else {
					// Load mobile videos
					sourceUrls = mobileVideoUrls;
					sourceTypes = mobileVideoSourceTypes;
				}

				// Loop through all the source urls and types then insert the sources to the video element
				for (let index = 0; index < sourceUrls.length; index++) {
					video.insertAdjacentHTML(
						'beforeend',
						`<source type='${sourceTypes[index]}' src='${sourceUrls[index]}'/>`,
					);
				}
			}

			videoBlock.addEventListener('play.video-block', function () {
				video.play();
			});

			videoBlock.addEventListener('pause.video-block', function () {
				video.pause();
			});

			video.onplay = function () {
				videoBlock.dispatchEvent(playerPlay);
			};

			video.onpause = function () {
				videoBlock.dispatchEvent(playerPause);
			};
		});
	},
};

// -------------------------------------
// Hooks
// -------------------------------------

document.addEventListener('DOMContentLoaded', function () {
	videoBlocks.init();
	youtubeVideos.init();
	vimeoVideos.init();
	html5Videos.init();
});

// PRODUCT RECOMMENDATIONS

// -------------------------------------
// Variables
// -------------------------------------

// Selectors
const RECOMMENDATIONS_SELECTOR = '.product-recommendations';

// -------------------------------------
// Helpers
// -------------------------------------
const initProductRecommendations = () => {
	const productRecommendations = document.querySelectorAll(
		RECOMMENDATIONS_SELECTOR,
	);

	if (productRecommendations.length === 0) {
		console.warn(
			`No elements found with selector: ${RECOMMENDATIONS_SELECTOR}`,
		);
		return;
	}

	const observer = new IntersectionObserver(handleIntersection, {
		rootMargin: '0px 0px 200px 0px',
	});

	productRecommendations.forEach((productRecommendation) => {
		observer.observe(productRecommendation);
	});
};

const handleIntersection = (entries, observer) => {
	if (!entries[0].isIntersecting) return;

	const $elem = entries[0].target;
	const url = $elem.dataset.url;

	observer.unobserve($elem);

	fetch(url)
		.then((response) => response.text())
		.then((text) => {
			const html = document.createElement('div');
			html.innerHTML = text;
			const recommendations = html.querySelector(RECOMMENDATIONS_SELECTOR);

			if (recommendations && recommendations.innerHTML.trim().length) {
				$elem.innerHTML = recommendations.innerHTML;
			}
		})
		.catch((e) => {
			console.error(e);
		});
};

// -------------------------------------
// Hooks
// -------------------------------------

document.addEventListener('DOMContentLoaded', () => {
	initProductRecommendations();
});

// HEADER/NAV

// Visual Nav setup
document.querySelectorAll('.header-menu__list--desktop').forEach((menu) => {
	const hasVisualNav = menu.querySelector('.header-menu__column--visual-nav');
	if (hasVisualNav) {
		menu.querySelectorAll('.header-menu__item--level-1').forEach((item) => {
			item.style.display = 'none';
		});
	}
});

// -------------------------------------
// Variables
// -------------------------------------

// Selectors
const HEADER_SECTION_SELECTOR = '.section--header';
const HEADER_SELECTOR = '.header';
const HAMBURGER_SELECTOR = '.header__link--menu';
const HEADER_NAV_WRAPPER_SELECTOR = '.header__nav-wrapper';
const MENU_LIST_SELECTOR = '.header-menu__list';
const MENU_ITEM_SELECTOR = '.header-menu__item--dropdown';
const MOBILE_MENU_ITEM_SELECTOR =
	'.header-menu__list--mobile .header-menu__item--dropdown';
const OPEN_MENU_ITEM_SELECTOR = '.header-menu__item--dropdown.js--is-open';
const DESKTOP_TOP_MENU_ITEM_SELECTOR =
	'.header-menu__list--desktop .header-menu__item--level-1.header-menu__item--dropdown';
const MENU_BUTTON_SELECTOR = '.header-menu__button';
const MOBILE_MENU_BUTTON_SELECTOR =
	'.header-menu__list--mobile .header-menu__button';
const DESKTOP_MENU_BUTTON_SELECTOR =
	'.header-menu__list--desktop .header-menu__button';
const MOBILE_MENU_LINK_SELECTOR =
	'.header-menu__list--mobile .header-menu__link';
const DESKTOP_MENU_LINK_SELECTOR =
	'.header-menu__list--desktop .header-menu__link';
const MENU_BACK_BUTTON_SELECTOR = '.header-menu__back';

// Classes
const HEADER_NAV_WRAPPER_SLIDE_CLASS = 'mobile-slide';
const LEVEL_1_MENU_ITEM_CLASS = 'header-menu__item--level-1';
const LEVEL_2_MENU_LIST_CLASS = 'header-menu__list--level-2';
const MENU_BUTTON_CLASS = 'header-menu__button';
const MENU_BACK_BUTTON_CLASS = 'header-menu__back';
const MENU_LINK_EMPTY_CLASS = 'header-menu__link--empty';
const OPEN_CLASS = 'js--is-open';

function syncFirstOpenExpandedState() {
	document
		.querySelectorAll('.first--is-open .header-menu__button')
		.forEach(function (btn) {
			btn.setAttribute('aria-expanded', 'true');
		});
}
const NO_SCROLL_CLASS = 'noscroll';

// Key codes
const INTERACTION_KEYS = [' ', 'Enter', 'Escape', 'Tab'];

// -------------------------------------
// Helper functions
// -------------------------------------

function initMobileMenu() {
	const menu = {
		$body: document.querySelector('body'),
		$header: document.querySelector(HEADER_SELECTOR),
		$headerNavWrapper: document.querySelector(HEADER_NAV_WRAPPER_SELECTOR),
		$hamburger: document.querySelector(HAMBURGER_SELECTOR),
		$items: document.querySelectorAll(MOBILE_MENU_ITEM_SELECTOR),
		$buttons: document.querySelectorAll(MOBILE_MENU_BUTTON_SELECTOR),
		$links: document.querySelectorAll(MOBILE_MENU_LINK_SELECTOR),
	};

	initMenuButtons(menu, 'mobile');
	initMenuLinks(menu, 'mobile');

	syncFirstOpenExpandedState();
}

function initDesktopMenu() {
	const menu = {
		$topLevelItems: document.querySelectorAll(DESKTOP_TOP_MENU_ITEM_SELECTOR),
		$buttons: document.querySelectorAll(DESKTOP_MENU_BUTTON_SELECTOR),
		$links: document.querySelectorAll(DESKTOP_MENU_LINK_SELECTOR),
	};

	initDesktopHover(menu.$topLevelItems);
	initMenuButtons(menu, 'desktop');
	initMenuLinks(menu, 'desktop');
}

function initMenuButtons(menu, source) {
	menu.$buttons.forEach(function (button) {
		button.menu = menu;
		button.source = source;
		button.type = 'button';

		button.addEventListener('click', handleClick);
		button.addEventListener('keydown', handleKeydown);
	});

	// If we're on mobile and using the slide layout, initialize back buttons
	if (
		source === 'mobile' &&
		menu.$headerNavWrapper &&
		menu.$headerNavWrapper.classList.contains(HEADER_NAV_WRAPPER_SLIDE_CLASS)
	) {
		const backButtons = document.querySelectorAll(MENU_BACK_BUTTON_SELECTOR);

		backButtons.forEach(function (button) {
			button.menu = menu;
			button.source = source;
			button.type = 'back-button';

			button.addEventListener('click', handleClick);
			button.addEventListener('keydown', handleKeydown);
		});
	}
}

function initMenuLinks(menu, source) {
	menu.$links.forEach(function (link) {
		link.menu = menu;
		link.source = source;
		link.type = 'link';

		link.addEventListener('click', handleClick);
		link.addEventListener('keydown', handleKeydown);
		link.addEventListener('focus', handleFocus);
	});
}

function initDesktopHover(topLevelItems) {
	topLevelItems.forEach(function (item) {
		item.addEventListener('mouseenter', handleHover);
		item.addEventListener('mouseleave', handleHover);
	});
}

function handleClick(event) {
	const $this = event.currentTarget;

	event.stopPropagation();

	if ($this.type === 'button') {
		handleMenuButtonInteraction($this, event);
	} else if ($this.type === 'back-button') {
		// parentItem might be null if HTML structure changed
		const item = event.target.closest(MENU_ITEM_SELECTOR);
		if (!item) return;
		const button = event.currentTarget;
		closeDropdown(item, button);
	} else {
		handleMenuLinkInteraction($this, event);
	}
}

function handleKeydown(event) {
	event.stopPropagation();
	handleKeyboardInteraction(event.currentTarget, event);
}

function handleFocus(event) {
	const $this = event.currentTarget;
	const parentItem = $this.parentElement;

	if (parentItem && parentItem.classList.contains(LEVEL_1_MENU_ITEM_CLASS)) {
		if ($this.menu.$topLevelItems) {
			$this.menu.$topLevelItems.forEach(function (item) {
				const childButton = item.querySelector(MENU_BUTTON_SELECTOR);
				if (item && childButton) {
					closeDropdown(item, childButton);
				}
			});
		}
	}
}

function handleHover(event) {
	const $this = event.currentTarget;
	const button = $this.querySelector(MENU_BUTTON_SELECTOR);
	if (!button) return;

	if (event.type === 'mouseenter') {
		// Wrap in a function for setTimeout
		setTimeout(function () {
			openDropdown($this, button);
		}, 80);
	} else {
		setTimeout(function () {
			closeDropdown($this, button);
		}, 80);
	}
}

function handleMenuButtonInteraction(button, event) {
	event.preventDefault();

	const parentItem = button.closest(MENU_ITEM_SELECTOR);
	if (!parentItem) return;

	if (
		parentItem.classList.contains(OPEN_CLASS) ||
		parentItem.classList.contains('first--is-open')
	) {
		closeDropdown(parentItem, button);
	} else {
		openDropdown(parentItem, button);

		// If we're using the slide layout and the button is top level, move focus to child level back button
		if (
			button.source === 'mobile' &&
			button.menu.$headerNavWrapper &&
			button.menu.$headerNavWrapper.classList.contains(
				HEADER_NAV_WRAPPER_SLIDE_CLASS,
			)
		) {
			if (parentItem.classList.contains(LEVEL_1_MENU_ITEM_CLASS)) {
				const backButton = parentItem.querySelector(MENU_BACK_BUTTON_SELECTOR);
				if (backButton) {
					// Delay setting the focus so that there's time for it to become visible
					setTimeout(function () {
						backButton.focus();
					}, 30);
				}
			}
		}
	}
}

function handleMenuLinkInteraction(link, event) {
	const href = link.getAttribute('href');
	let path = window.location.pathname;
	let isCurrentLink = href === path;
	let isCurrentLinkOrAnchor = false;

	if (link.classList.contains(MENU_LINK_EMPTY_CLASS) || isCurrentLink) {
		isCurrentLinkOrAnchor = true;
	}

	if (isCurrentLinkOrAnchor) {
		event.preventDefault();

		if (link.source === 'mobile') {
			closeMenu(link.menu);
		} else {
			const topLevelItem = link.closest(DESKTOP_TOP_MENU_ITEM_SELECTOR);
			if (!topLevelItem) return;
			const button = topLevelItem.querySelector(MENU_BUTTON_SELECTOR);
			if (button) {
				closeDropdown(topLevelItem, button);
			}
		}
	} else {
		if (event.key === ' ') {
			event.preventDefault();
			window.location.assign(href);
		}
	}
}

function handleKeyboardInteraction(element, event) {
	const key = event.key;

	if (INTERACTION_KEYS.includes(key)) {
		if (key === ' ' || key === 'Enter') {
			// If element is a button
			if (element.classList.contains(MENU_BUTTON_CLASS)) {
				handleMenuButtonInteraction(element, event);
			} else if (element.classList.contains(MENU_BACK_BUTTON_CLASS)) {
				const parentItem = element.closest(MENU_ITEM_SELECTOR);
				if (!parentItem) return;
				const parentButton = parentItem.querySelector(MENU_BUTTON_SELECTOR);
				if (parentButton) parentButton.focus();
				handleMenuButtonInteraction(element, event);
			} else if (key === 'Enter') {
				handleMenuLinkInteraction(element, event);
			}
		} else if (key === 'Escape') {
			if (element.source === 'mobile') {
				let closestOpenDropdown;
				if (
					element.classList.contains(MENU_BUTTON_CLASS) ||
					element.classList.contains(MENU_BACK_BUTTON_CLASS)
				) {
					closestOpenDropdown = element.closest(OPEN_MENU_ITEM_SELECTOR);
				} else {
					closestOpenDropdown = element.closest(MENU_ITEM_SELECTOR);
				}

				if (closestOpenDropdown) {
					const button =
						closestOpenDropdown.querySelector(MENU_BUTTON_SELECTOR);
					if (button) {
						closeDropdown(closestOpenDropdown, button);
						button.focus();
					}
				} else {
					closeMenu(element.menu);
				}
			} else {
				const topLevelItem = element.closest(DESKTOP_TOP_MENU_ITEM_SELECTOR);
				if (!topLevelItem) return;
				const button = topLevelItem.querySelector(MENU_BUTTON_SELECTOR);
				if (button) {
					closeDropdown(topLevelItem, button);
					button.focus();
				}
			}
		} else if (key === 'Tab') {
			if (
				element.source === 'mobile' &&
				element.menu.$headerNavWrapper &&
				element.menu.$headerNavWrapper.classList.contains(
					HEADER_NAV_WRAPPER_SLIDE_CLASS,
				)
			) {
				const parentList = element.closest(MENU_LIST_SELECTOR);
				if (
					parentList &&
					parentList.classList.contains(LEVEL_2_MENU_LIST_CLASS)
				) {
					const $this = event.target;
					const focusableElements = parentList.querySelectorAll(
						'[tabindex="0"], a[href], button:not([disabled]), [role="button"]',
					);
					const firstFocusableElement = focusableElements[0];
					const lastFocusableElement =
						focusableElements[focusableElements.length - 1];

					if (event.shiftKey) {
						if ($this === firstFocusableElement) {
							event.preventDefault();
							lastFocusableElement.focus();
						}
					} else if ($this === lastFocusableElement) {
						event.preventDefault();
						firstFocusableElement.focus();
					}
				} else {
					const dialog = element.closest('[role="dialog"][aria-modal="true"]');
					if (dialog) {
						const focusableElements = dialog.querySelectorAll(
							'a[href], button:not([disabled]), textarea, input, select, [tabindex]:not([tabindex="-1"])',
						);
						const first = focusableElements[0];
						const last = focusableElements[focusableElements.length - 1];

						if (event.shiftKey && document.activeElement === first) {
							event.preventDefault();
							last.focus();
						} else if (!event.shiftKey && document.activeElement === last) {
							event.preventDefault();
							first.focus();
						}
					}
				}
			}
		}
	}
}

function closeMenu(menu) {
	menu.$body && menu.$body.classList.remove(NO_SCROLL_CLASS);
	menu.$header && menu.$header.classList.remove(OPEN_CLASS);
	menu.$hamburger && menu.$hamburger.classList.remove(OPEN_CLASS);
	removeClassFromElements(menu.$items, OPEN_CLASS);
	setAttributeForElements(menu.$buttons, 'aria-expanded', 'false');
	syncFirstOpenExpandedState();
}

function openDropdown(item, button) {
	if (item && button) {
		item.classList.add(OPEN_CLASS);
		button.setAttribute('aria-expanded', 'true');
	}
}

function closeDropdown(item, button) {
	if (!item || !button) return;

	// childList may be null if there's no nested list
	const childList = item.querySelector(MENU_LIST_SELECTOR);
	item.classList.remove(OPEN_CLASS);
	item.classList.remove('first--is-open');
	button.setAttribute('aria-expanded', 'false');

	if (childList) {
		// childListDropdownItems is always a NodeList (never null), but might be empty
		const childListDropdownItems =
			childList.querySelectorAll(MENU_ITEM_SELECTOR);
		childListDropdownItems.forEach(function (childItem) {
			// if (!childItem) return;
			// const childButton = childItem.querySelector(MENU_BUTTON_SELECTOR);
			// childItem.classList.remove(OPEN_CLASS);
			// if (childButton) {
			//   childButton.setAttribute('aria-expanded', 'false');
			// }
		});
	}
}

// Utility helpers used above
function removeClassFromElements(nodeList, className) {
	if (!nodeList) return;
	nodeList.forEach((el) => {
		if (el && el.classList) {
			el.classList.remove(className);
		}
	});
}

function setAttributeForElements(nodeList, attrName, attrValue) {
	if (!nodeList) return;
	nodeList.forEach((el) => {
		if (el && el.setAttribute) {
			el.setAttribute(attrName, attrValue);
		}
	});
}

// -------------------------------------
// Hooks
// -------------------------------------

document.addEventListener('DOMContentLoaded', function () {
	const mobileMedia = window.matchMedia('(max-width: 1023px)');

	if (mobileMedia.matches) {
		initMobileMenu();
	} else {
		initDesktopMenu();
	}
});

window.addEventListener('resize', function () {
	const mobileMedia = window.matchMedia('(max-width: 1023px)');

	if (mobileMedia.matches) {
		initMobileMenu();
	} else {
		initDesktopMenu();
	}
});
// ----------------------------------------------------------------------------
// Section: Site Header
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Variables
// -------------------------------------

// Selectors
const HAMBURGER_CLASS = 'header__link--menu';
const MENU_WRAPPER_SELECTOR = '.header__nav-wrapper';

// -------------------------------------
// Helper functions
// -------------------------------------

function isSafari() {
	const userAgent = navigator.userAgent.toLowerCase();
	return (
		userAgent.includes('safari') &&
		!userAgent.includes('chrome') &&
		!userAgent.includes('firefox') &&
		!(
			userAgent.includes('android') ||
			userAgent.includes('iphone') ||
			userAgent.includes('ipad')
		)
	);
}

// Open the menu
function openMenu(menu) {
	if (menu.$body) menu.$body.classList.add(NO_SCROLL_CLASS);
	if (menu.$header) menu.$header.classList.add(OPEN_CLASS);
	if (menu.$hamburger) {
		menu.$hamburger.classList.add(OPEN_CLASS);
		menu.$hamburger.setAttribute('aria-expanded', 'true');
	}
	if (typeof syncFirstOpenExpandedState === 'function')
		syncFirstOpenExpandedState();
}

// Close the menu
function closeMenu(menu) {
	if (menu.$body) menu.$body.classList.remove(NO_SCROLL_CLASS);
	if (menu.$header) menu.$header.classList.remove(OPEN_CLASS);
	if (menu.$hamburger) {
		menu.$hamburger.classList.remove(OPEN_CLASS);
		menu.$hamburger.setAttribute('aria-expanded', 'false');
	}
	if (menu.$items) removeClassFromElements(menu.$items, OPEN_CLASS);
	if (menu.$buttons)
		setAttributeForElements(menu.$buttons, 'aria-expanded', 'false');
	if (typeof syncFirstOpenExpandedState === 'function')
		syncFirstOpenExpandedState();
}

// Remove a given class from a list of elements
function removeClassFromElements(elems, className) {
	elems.forEach(function (elem) {
		elem.classList.remove(className);
	});
}

// Set the value of a given attribute for a list of elements
function setAttributeForElements(elems, attribute, value) {
	elems.forEach(function (elem) {
		elem.setAttribute(attribute, value);
	});
}

// -------------------------------------
// Hooks
// -------------------------------------

document.addEventListener('DOMContentLoaded', function () {
	if (isSafari()) {
		document.body.classList.add('safari');
	}

	const menu = {
		$body: document.querySelector('body'),
		$header: document.querySelector(HEADER_SELECTOR),
		$hamburger: document.querySelector(HAMBURGER_SELECTOR),
		$items: document.querySelectorAll(MENU_ITEM_SELECTOR),
		$buttons: document.querySelectorAll(MENU_BUTTON_SELECTOR),
	};

	// Toggle the mobile menu when the hamburger is clicked
	// Otherwise, close the menu if clicked outside of it
	menu.$body.addEventListener('click', function (event) {
		const $this = event.target;

		let hamburgerClick = false;
		let hamburger = null;

		if ($this.classList.contains(HAMBURGER_CLASS)) {
			hamburgerClick = true;
			hamburger = $this;
		} else {
			const closestHamburger = $this.closest(HAMBURGER_SELECTOR);

			if (closestHamburger !== null) {
				hamburgerClick = true;
				hamburger = closestHamburger;
			}
		}

		if (hamburgerClick) {
			event.preventDefault();

			if (hamburger.classList.contains(OPEN_CLASS)) {
				closeMenu(menu);
			} else {
				openMenu(menu);
			}
		} else if ($this.closest(MENU_WRAPPER_SELECTOR) === null) {
			closeMenu(menu);
		}
	});
});

// Sync content between elements when one element changes
const syncCartNumbers = (sourceSelector, targetSelector) => {
	const sourceElement = document.querySelector(sourceSelector);
	const targetElement = document.querySelector(targetSelector);

	if (sourceElement && targetElement) {
		document.addEventListener('rebuy:cart.change', (event) => {
			// Listen for cart changes

			fetch('/cart.js')
				.then((response) => response.json())
				.then((data) => {
					console.log('cart data:', data);
					sourceElement.innerHTML = data.item_count;
					targetElement.innerHTML = data.item_count;
				})
				.catch((error) => console.error('Error fetching cart data:', error));
		});
	}
};

// Example usage
syncCartNumbers('#cart__item-count-mobile', '#cart__item-count-desktop');

// Collection Search and Discovery

// -------------------------------------
// Variables
// -------------------------------------
// Selectors
const FILTER_WRAPPER = '#FiltersWrapperDesktop';
const PRODUCT_COUNT = '#ProductCount';
const PRODUCT_GRID_CONTAINER = '#ProductGridContainer';
const PRODUCT_GRID = '#ProductGrid';
const FILTER_DETAILS_ELEMENTS =
	'#FiltersForm .js--filter, #FiltersFormMobile .js--filter';
const FILTER_ELEMENT = '.js--filter';
const ACTIVE_FILTER_MOBILE = '.js--active-filters-mobile';
const ACTIVE_FILTER_DESKTOP = '.js--active-filters-desktop';
const FILTERS_SELECTED = '.js--filters__selected';
const FILTERS_SUMMARY = '.js--filters__summary';
const FILTERS_FORM = 'FiltersForm';
const SORT_FORM_DESKTOP = 'SortForm';
const SORT_FORM_MOBILE = 'SortFormMobile';
const SORT_SELECTOR = '#SortBy';

// Classes & Other
const LOADING_CLASS = 'loading';
const COLLECTION_PROMO_CHECK_INTERVAL = 30000;

const updateCollectionPromoSchedule = (root = document) => {
	const productGrid = root.querySelector(PRODUCT_GRID);
	if (!productGrid) return;

	const isScheduleEnabled = productGrid.dataset.promoScheduleEnabled === 'true';
	const currentPage = parseInt(productGrid.dataset.currentPage || '1', 10);
	if (!isScheduleEnabled || currentPage !== 1) return;

	const promoTile = productGrid.querySelector('[data-promo-tile="true"]');
	if (!promoTile) return;

	const startTs = parseInt(productGrid.dataset.promoStartTs || '0', 10);
	const endTs = parseInt(productGrid.dataset.promoEndTs || '0', 10);
	const nowTs = Math.floor(Date.now() / 1000);
	const shouldShowPromo =
		(!startTs || nowTs >= startTs) && (!endTs || nowTs <= endTs);

	const hiddenByScheduler = productGrid.querySelector(
		'[data-hidden-by-promo-schedule="true"]',
	);
	const productTiles = Array.from(
		productGrid.querySelectorAll('[data-product-tile="true"]'),
	);

	if (shouldShowPromo) {
		promoTile.classList.remove('collection-promo-grid-item--hidden');

		const visibleTiles = Array.from(productGrid.children).filter((tile) => {
			return (
				!tile.classList.contains('collection-promo-grid-item--hidden') &&
				!tile.classList.contains('collection-product-grid-item--hidden')
			);
		});

		if (visibleTiles.length > 12 && !hiddenByScheduler) {
			const lastVisibleProduct = [...productTiles].reverse().find((tile) => {
				return !tile.classList.contains('collection-product-grid-item--hidden');
			});

			if (lastVisibleProduct) {
				lastVisibleProduct.classList.add(
					'collection-product-grid-item--hidden',
				);
				lastVisibleProduct.setAttribute(
					'data-hidden-by-promo-schedule',
					'true',
				);
			}
		}
	} else {
		promoTile.classList.add('collection-promo-grid-item--hidden');

		if (hiddenByScheduler) {
			hiddenByScheduler.classList.remove(
				'collection-product-grid-item--hidden',
			);
			hiddenByScheduler.removeAttribute('data-hidden-by-promo-schedule');
		}
	}
};

const initCollectionPromoScheduleWatcher = () => {
	updateCollectionPromoSchedule(document);

	if (window.collectionPromoScheduleInterval) return;
	window.collectionPromoScheduleInterval = window.setInterval(() => {
		updateCollectionPromoSchedule(document);
	}, COLLECTION_PROMO_CHECK_INTERVAL);
};

// -------------------------------------
// Hooks
// -------------------------------------

// Class 'FiltersForm' to handle filter functionalities
class FiltersForm extends HTMLElement {
	constructor() {
		// Initializing event handlers and methods for filtering
		super();
		this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

		// Debouncing the submit handler to avoid frequent submissions
		this.debouncedOnSubmit = debounce((event) => {
			this.onSubmitHandler(event);
		}, 500);

		// Adding event listeners for filter form input and keyup actions
		const filterForm = this.querySelector('form');
		filterForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

		// Adding an event listener for the escape key to close details elements
		const filterWrapper = this.querySelector(FILTER_WRAPPER);
		if (filterWrapper) filterWrapper.addEventListener('keyup', onKeyUpEscape);
	}

	// Static method to set listeners for popstate events
	static setListeners() {
		const onHistoryChange = (event) => {
			const searchParams = event.state
				? event.state.searchParams
				: FiltersForm.searchParamsInitial;
			if (searchParams === FiltersForm.searchParamsPrev) return;
			FiltersForm.renderPage(searchParams, null, false);
		};
		window.addEventListener('popstate', onHistoryChange);
	}

	// Static method to render the page with updated filter parameters
	static renderPage(searchParams, event, updateURLHash = true) {
		// Implementation details for rendering different sections of the page
		FiltersForm.searchParamsPrev = searchParams;
		const sections = FiltersForm.getSections();
		const countContainer = document.querySelector(PRODUCT_COUNT);
		document
			.querySelector(PRODUCT_GRID_CONTAINER)
			.querySelector('.collection')
			.classList.add(LOADING_CLASS);

		console.log(searchParams);

		if (countContainer) {
			countContainer.classList.add(LOADING_CLASS);
		}

		sections.forEach((section) => {
			const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
			const filterDataUrl = (element) => element.url === url;

			FiltersForm.filterData.some(filterDataUrl)
				? FiltersForm.renderSectionFromCache(filterDataUrl, event)
				: FiltersForm.renderSectionFromFetch(url, event);
		});

		// Updating the URL hash if required
		if (updateURLHash) FiltersForm.updateURLHash(searchParams);
	}

	static renderSectionFromFetch(url, event) {
		fetch(url)
			.then((response) => response.text())
			.then((responseText) => {
				const html = responseText;
				FiltersForm.filterData = [...FiltersForm.filterData, { html, url }];
				FiltersForm.renderFilters(html, event);
				FiltersForm.renderProductGridContainer(html);
				FiltersForm.renderProductCount(html);
			});
	}

	static renderSectionFromCache(filterDataUrl, event) {
		const html = FiltersForm.filterData.find(filterDataUrl).html;
		FiltersForm.renderFilters(html, event);
		FiltersForm.renderProductGridContainer(html);
		FiltersForm.renderProductCount(html);
	}

	static renderProductGridContainer(html) {
		document.querySelector(PRODUCT_GRID_CONTAINER).innerHTML = new DOMParser()
			.parseFromString(html, 'text/html')
			.querySelector(PRODUCT_GRID_CONTAINER).innerHTML;
	}

	static renderProductCount(html) {
		const countContainers = document.querySelectorAll(PRODUCT_COUNT);
		const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
		const counts = parsedHTML.querySelectorAll(PRODUCT_COUNT);

		if (countContainers) {
			countContainers.forEach((container, index) => {
				if (counts[index]) {
					container.innerHTML = counts[index].innerHTML;
					container.classList.remove(LOADING_CLASS);
				}
			});
		}
	}

	static renderFilters(html, event) {
		const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

		const filterDetailsElements = parsedHTML.querySelectorAll(
			FILTER_DETAILS_ELEMENTS,
		);
		const matchesIndex = (element) => {
			const jsFilter = event ? event.target.closest(FILTER_ELEMENT) : undefined;
			return jsFilter
				? element.dataset.index === jsFilter.dataset.index
				: false;
		};
		const filtersToRender = Array.from(filterDetailsElements).filter(
			(element) => !matchesIndex(element),
		);
		const countsToRender = Array.from(filterDetailsElements).find(matchesIndex);

		filtersToRender.forEach((element) => {
			document.querySelector(
				`${FILTER_ELEMENT}[data-index="${element.dataset.index}"]`,
			).innerHTML = element.innerHTML;
		});

		FiltersForm.renderActiveFilters(parsedHTML);

		if (countsToRender)
			FiltersForm.renderCounts(
				countsToRender,
				event.target.closest(FILTER_ELEMENT),
			);
	}

	static renderActiveFilters(html) {
		const activeFilterElementSelectors = [
			ACTIVE_FILTER_MOBILE,
			ACTIVE_FILTER_DESKTOP,
		];

		activeFilterElementSelectors.forEach((selector) => {
			const activeFiltersElement = html.querySelector(selector);
			if (!activeFiltersElement) return;
			document.querySelector(selector).innerHTML =
				activeFiltersElement.innerHTML;
		});
	}

	static renderCounts(source, target) {
		const targetElement = target.querySelector(FILTERS_SELECTED);
		const sourceElement = source.querySelector(FILTERS_SELECTED);

		const targetElementAccessibility = target.querySelector(FILTERS_SUMMARY);
		const sourceElementAccessibility = source.querySelector(FILTERS_SUMMARY);

		if (sourceElement && targetElement) {
			target.querySelector(FILTERS_SELECTED).outerHTML =
				source.querySelector(FILTERS_SELECTED).outerHTML;
		}

		if (targetElementAccessibility && sourceElementAccessibility) {
			target.querySelector(FILTERS_SUMMARY).outerHTML =
				source.querySelector(FILTERS_SUMMARY).outerHTML;
		}
	}

	static updateURLHash(searchParams) {
		history.pushState(
			{ searchParams },
			'',
			`${window.location.pathname}${searchParams && '?'.concat(searchParams)}`,
		);
	}

	static getSections() {
		return [
			{
				section: document.querySelector(PRODUCT_GRID).dataset.id,
			},
		];
	}

	// Handling event changes for sorting selectors
	connectedCallback() {
		const sortSelectors = document.querySelectorAll(SORT_SELECTOR);

		if (sortSelectors.length > 0) {
			sortSelectors.forEach((sortSelector) => {
				sortSelector.addEventListener(
					'change',
					this.handleSelectorChange.bind(this),
				);
			});
		}
	}

	// Event handler for sorting selector changes
	handleSelectorChange(event) {
		const sortSelectors = document.querySelectorAll(SORT_SELECTOR);
		const selectedValue = event.target.value;

		// Remove the event listener from the current element
		event.target.removeEventListener('change', this.handleSelectorChange);
		sortSelectors.forEach((otherSelector) => {
			if (otherSelector !== event.target) {
				otherSelector.value = selectedValue;
			}
		});

		event.target.addEventListener(
			'change',
			this.handleSelectorChange.bind(this),
		);
	}

	// Method to create search parameters from form data
	createSearchParams(form) {
		if (!form) return '';

		const priceRangeElement = form.querySelector('price-range');
		const formData = new FormData(form);
		const searchParams = new URLSearchParams(formData);

		if (priceRangeElement) {
			const inputs = priceRangeElement.querySelectorAll('input');
			const minInput = inputs[0];
			const maxInput = inputs[1];

			const lowestPrice = Number(minInput?.getAttribute('min')) ?? null;
			const highestPrice = Number(maxInput?.getAttribute('max')) ?? null;

			// Ensure filter.v.price.gte is not below the lowest price
			const priceGte = Number(searchParams.get('filter.v.price.gte'));
			if (!isNaN(priceGte) && lowestPrice !== null && priceGte < lowestPrice) {
				searchParams.set('filter.v.price.gte', lowestPrice);
			}

			// Ensure filter.v.price.lte is not above the highest price
			const priceLte = Number(searchParams.get('filter.v.price.lte'));
			if (
				!isNaN(priceLte) &&
				highestPrice !== null &&
				priceLte > highestPrice
			) {
				searchParams.set('filter.v.price.lte', highestPrice);
			}
		}

		return searchParams.toString();
	}

	// Event handler for form submissions
	onSubmitForm(searchParams, event) {
		console.log(searchParams);
		FiltersForm.renderPage(searchParams, event);
	}

	// Event handler for form input changes
	onSubmitHandler(event) {
		event.preventDefault();
		const sortFilterForms = document.querySelectorAll('filters-form form');

		const forms = [];
		const isMobile = event.target.closest('form').id === SORT_FORM_MOBILE;

		sortFilterForms.forEach((form) => {
			if (!isMobile) {
				if (form.id === SORT_FORM_DESKTOP || form.id === FILTERS_FORM) {
					forms.push(this.createSearchParams(form));
				}
			} else if (form.id === SORT_FORM_MOBILE || form.id === FILTERS_FORM) {
				forms.push(this.createSearchParams(form));
			}
		});
		this.onSubmitForm(forms.join('&'), event);
	}

	// Event handler for active filter clicks
	onActiveFilterClick(event) {
		event.preventDefault();
		const url =
			event.currentTarget.href.indexOf('?') == -1
				? ''
				: event.currentTarget.href.slice(
						event.currentTarget.href.indexOf('?') + 1,
					);
		FiltersForm.renderPage(url);
	}
}

FiltersForm.filterData = [];
FiltersForm.searchParamsInitial = window.location.search.slice(1);
FiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('filters-form', FiltersForm);
FiltersForm.setListeners();

class PriceRange extends HTMLElement {
	constructor() {
		super();
		this.querySelectorAll('input').forEach((element) =>
			element.addEventListener('change', this.onRangeChange.bind(this)),
		);
		this.setMinAndMaxValues();
	}

	onRangeChange(event) {
		this.adjustToValidValues(event.currentTarget);
		this.setMinAndMaxValues();
	}

	setMinAndMaxValues() {
		const inputs = this.querySelectorAll('input');
		const minInput = inputs[0];
		const maxInput = inputs[1];
		if (maxInput.value) minInput.setAttribute('max', maxInput.value);
		if (minInput.value) maxInput.setAttribute('min', minInput.value);
		if (minInput.value === '') maxInput.setAttribute('min', 0);
		if (maxInput.value === '')
			minInput.setAttribute('max', maxInput.getAttribute('max'));
	}

	adjustToValidValues(input) {
		const value = Number(input.value);
		const min = Number(input.getAttribute('min'));
		const max = Number(input.getAttribute('max'));

		if (value < min) input.value = min;
		if (value > max) input.value = max;
	}
}
customElements.define('price-range', PriceRange);

class FilterRemove extends HTMLElement {
	constructor() {
		super();
		const filterLink = this.querySelector('a');
		filterLink.setAttribute('role', 'button');
		filterLink.addEventListener('click', this.closeFilter.bind(this));
		filterLink.addEventListener('keyup', (event) => {
			event.preventDefault();
			if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
		});
	}

	closeFilter(event) {
		event.preventDefault();
		const form =
			this.closest('filters-form') || document.querySelector('filters-form');
		form.onActiveFilterClick(event);
	}
}
customElements.define('filter-remove', FilterRemove);

// -------------------------------------
// Helpers
// -------------------------------------

// Limit the frequency of a function's execution
function debounce(fn, wait) {
	let t;
	return (...args) => {
		clearTimeout(t);
		t = setTimeout(() => fn.apply(this, args), wait);
	};
}

// Function to handle keyup 'Escape' event to close details element
function onKeyUpEscape(event) {
	if (event.code.toUpperCase() !== 'ESCAPE') return;

	const openDetailsElement = event.target.closest('details[open]');
	if (!openDetailsElement) return;

	const summaryElement = openDetailsElement.querySelector('summary');
	openDetailsElement.removeAttribute('open');
	summaryElement.setAttribute('aria-expanded', false);
	summaryElement.focus();
}
// function toggleFilters(action) {
//     const filtersForm = document.querySelector(FILTERS_FORM_SELECTOR);

//     if (!filtersForm) {
//         console.warn(`No element found for selector: ${FILTERS_FORM_SELECTOR}`);
//         return;
//     }

//     const filters = filtersForm.querySelectorAll(FILTER_ELEMENT);

//     if (filtersForm.classList.contains(CLOSED_FILTERS_CLASS) && filters.length > 0) {
//         filters.forEach(function (filter) {
//             if (
//                 filter &&
//                 (action === 'open' ? !filter.hasAttribute(OPEN_ATTR) : filter.hasAttribute(OPEN_ATTR))
//             ) {
//                 if (action === 'open') {
//                     filter.setAttribute(OPEN_ATTR, true);
//                 } else {
//                     filter.removeAttribute(OPEN_ATTR);
//                 }
//             }
//         });
//     }
// }

function toggleDropdowns() {
	const dropdown = document.querySelectorAll('select');

	dropdown.forEach((el) => {
		el.addEventListener('focus', function () {
			el.classList.add('js--opened');
		});

		el.addEventListener('blur', function () {
			el.classList.remove('js--opened');
		});

		el.addEventListener('change', function () {
			el.classList.remove('js--opened');
		});
	});

	document.addEventListener('DOMContentLoaded', () => {
		// Select all details elements with the class js--filter
		const filterDetailsElements =
			document.querySelectorAll('details.js--filter');

		filterDetailsElements.forEach((details) => {
			details.addEventListener('toggle', () => {
				// Only proceed if the details element is opened
				if (details.hasAttribute('open')) {
					// Close all other details elements
					filterDetailsElements.forEach((otherDetails) => {
						if (otherDetails !== details) {
							otherDetails.removeAttribute('open');
						}
					});
				}
			});
		});

		// Optional: Ensure only one details element is open on page load
		const openDetail = Array.from(filterDetailsElements).find((detail) =>
			detail.hasAttribute('open'),
		);
		if (openDetail) {
			filterDetailsElements.forEach((detail) => {
				if (detail !== openDetail) {
					detail.removeAttribute('open');
				}
			});
		}
	});
}

// Function to handle click events on summary elements within details
function handleFilterClick(event) {
	const summaryElement = event.currentTarget;
	const detailsElement = summaryElement.parentElement;

	// // Close all other details elements except the clicked one
	// closeAllFiltersExcept(detailsElement);

	// // Toggle 'open' attribute on the clicked details element
	// detailsElement.toggleAttribute(OPEN_ATTR);
}

// // Function to close all details elements except the clicked one
// function closeAllFiltersExcept(clickedFilter) {
//     const filterDetailsElements = document.querySelectorAll(FILTER_DETAILS_ELEMENTS);
//     filterDetailsElements.forEach(filter => {
//         if (filter !== clickedFilter) {
//             filter.removeAttribute(OPEN_ATTR);
//         }
//     });
// }

// Add click event listeners to all summary elements within filter details
const summaryElements = document.querySelectorAll(
	`${FILTER_DETAILS_ELEMENTS} summary`,
);
summaryElements.forEach((summary) => {
	summary.addEventListener('click', handleFilterClick);
});

// Add click event listeners to all filter elements
const filterElements = document.querySelectorAll(FILTERS_SUMMARY);
filterElements.forEach((filter) => {
	filter.addEventListener('click', handleFilterClick);
});

// Function to initialize filter event listeners
function initializeFilterEventListeners() {
	const filterElements = document.querySelectorAll(FILTERS_SUMMARY);
	filterElements.forEach((filter) => {
		filter.addEventListener('click', handleFilterClick);
	});
}

function handleFiltersByViewport() {
	const breakpoint = window.matchMedia('(max-width: 1023px)');
	const action = breakpoint.matches ? 'close' : 'open';

	toggleDropdowns();
	// toggleFilters
	initializeFilterEventListeners();
}

// -------------------------------------
// Hooks
// -------------------------------------

document.addEventListener('DOMContentLoaded', handleFiltersByViewport);

window.addEventListener('resize', handleFiltersByViewport);

// -------------------------------------
// Hooks
// -------------------------------------

// You must define handleFiltersByViewport somewhere above or in another file
// Otherwise this line will throw: "Uncaught ReferenceError: handleFiltersByViewport is not defined"
document.addEventListener('DOMContentLoaded', handleFiltersByViewport);
window.addEventListener('resize', handleFiltersByViewport);

// Filter Close on outside click
$(document).on('click', function (event) {
	const $openGroup = $('.filter-group[open]');
	const $clickedGroup = $(event.target).closest('.filter-group');

	if ($openGroup.length) {
		// Case A: clicked completely outside any filter-group
		// Case B: clicked inside a different filter-group than the one that’s open
		if (
			!$clickedGroup.length ||
			($clickedGroup.length && !$clickedGroup.is($openGroup))
		) {
			$openGroup.removeAttr('open');
		}
	}
});

$(document).ready(function () {
	var $select = $('#SortBy');
	var longest = '';

	$select.find('option').each(function () {
		if ($(this).text().length > longest.length) {
			longest = $(this).text();
		}
	});

	// Create temporary span to measure text width
	var $temp = $('<span>')
		.text(longest)
		.css({
			position: 'absolute',
			visibility: 'hidden',
			'white-space': 'nowrap',
			font: $select.css('font'),
		})
		.appendTo('body');

	// Apply width (+ extra for dropdown arrow)
	$select.css('width', $temp.width() + 40);

	$temp.remove();

	if (window.pageYOffset >= 43) {
		document.body.classList.add('page-scrolled');
	} else {
		document.body.classList.remove('page-scrolled');
	}

	window.addEventListener('scroll', () => {
		if (window.pageYOffset >= 43) {
			document.body.classList.add('page-scrolled');
		} else {
			document.body.classList.remove('page-scrolled');
		}
	});
});

// Update alt text for Rebuy product images
function updateRebuyImageAltText() {
	const rebuyImages = document.querySelectorAll('.rebuy-product-image img');
	rebuyImages.forEach((img) => {
		let currentAlt = img.getAttribute('alt');
		if (currentAlt && !currentAlt.includes('Opens product page for ')) {
			// Remove "View" word from anywhere in the alt text
			currentAlt = currentAlt
				.replace(/\bView\b/gi, '')
				.replace(/\s+/g, ' ')
				.trim();
			// Set new alt text format
			img.setAttribute('alt', 'Opens product page for ' + currentAlt);
		}
	});
}

// Run on page load
updateRebuyImageAltText();

// Listen for Rebuy widget updates
document.addEventListener('rebuy:ready', updateRebuyImageAltText);
document.addEventListener('rebuy:widget.loaded', updateRebuyImageAltText);
document.addEventListener('rebuy:cart.change', updateRebuyImageAltText);

// Watch for cart modal opening
const cartModal = document.querySelector('#mini-cart');
if (cartModal) {
	const cartObserver = new MutationObserver((mutations) => {
		mutations.forEach((mutation) => {
			if (
				mutation.type === 'attributes' &&
				mutation.attributeName === 'class'
			) {
				if (cartModal.classList.contains('is-open')) {
					// Cart opened, wait a bit for content to load, then update
					setTimeout(updateRebuyImageAltText, 100);
				}
			}
			// Also watch for added nodes (new content added to cart)
			if (mutation.addedNodes.length) {
				setTimeout(updateRebuyImageAltText, 100);
			}
		});
	});

	cartObserver.observe(cartModal, {
		attributes: true,
		attributeFilter: ['class'],
		childList: true,
		subtree: true,
	});
}

// Watch for cart confirmation modal opening
const cartConfirmationModal = document.querySelector(
	'#cart_confirmation, [id*="cart"], .modal--open',
);
if (cartConfirmationModal) {
	const confirmationObserver = new MutationObserver((mutations) => {
		mutations.forEach((mutation) => {
			if (
				mutation.type === 'attributes' &&
				mutation.attributeName === 'class'
			) {
				const target = mutation.target;
				if (
					target.classList.contains('modal--open') ||
					target.classList.contains('is-open')
				) {
					setTimeout(updateRebuyImageAltText, 100);
				}
			}
			if (mutation.addedNodes.length) {
				setTimeout(updateRebuyImageAltText, 100);
			}
		});
	});

	confirmationObserver.observe(document.body, {
		attributes: true,
		attributeFilter: ['class'],
		childList: true,
		subtree: true,
	});
}

// Use MutationObserver to watch for dynamically added Rebuy elements anywhere in the document
const rebuyObserver = new MutationObserver((mutations) => {
	mutations.forEach((mutation) => {
		if (mutation.addedNodes.length) {
			mutation.addedNodes.forEach((node) => {
				if (node.nodeType === 1) {
					// Element node
					if (node.classList && node.classList.contains('rebuy-widget')) {
						setTimeout(updateRebuyImageAltText, 100);
					} else if (
						node.querySelector &&
						node.querySelector('.rebuy-product-image img')
					) {
						setTimeout(updateRebuyImageAltText, 100);
					}
				}
			});
		}
	});
});

// Start observing when DOM is ready
if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', () => {
		// Observe the entire document for Rebuy widgets
		rebuyObserver.observe(document.body, {
			childList: true,
			subtree: true,
		});
	});
} else {
	// Observe the entire document for Rebuy widgets
	rebuyObserver.observe(document.body, {
		childList: true,
		subtree: true,
	});
}

document.addEventListener('rebuy.ready', (event) => {
	setTimeout(() => {
		const closeBtn = document.querySelector(
			'.rebuy-quick-view-dropdown__close',
		);
		if (closeBtn) {
			closeBtn.setAttribute('aria-label', 'Close');
		}

		const rebuyQuicViewDropdownContainer = document.querySelector(
			'.rebuy-quick-view-dropdown__container',
		);
		if (rebuyQuicViewDropdownContainer) {
			rebuyQuicViewDropdownContainer.setAttribute('role', 'dialog');
			rebuyQuicViewDropdownContainer.setAttribute('aria-modal', 'true');
			rebuyQuicViewDropdownContainer.setAttribute(
				'aria-label',
				'Quick View Search',
			);
		}

		const rebuyQuickView = document.querySelector(
			'#rebuy-quick-view-dropdown-search .rebuy-quick-view-dropdown',
		);
		if (rebuyQuickView) {
			rebuyQuickView.removeAttribute('role');
			rebuyQuickView.removeAttribute('aria-labelledby');
			rebuyQuickView.removeAttribute('aria-describedby');
		}

		// Add screen reader only instructions before the live filter input
		const rebuyQuickViewSearchInput =
			rebuyQuicViewDropdownContainer &&
			rebuyQuicViewDropdownContainer.querySelector('#searchInput');
		if (rebuyQuickViewSearchInput) {
			const screenreaderText = document.createElement('span');
			screenreaderText.className = 'sr-only';
			screenreaderText.id = 'rebuy-quick-view-search-instructions';
			screenreaderText.textContent =
				'The following text field filters the results that follow as you type.';
			rebuyQuickViewSearchInput.parentNode.insertBefore(
				screenreaderText,
				rebuyQuickViewSearchInput,
			);
			rebuyQuickViewSearchInput.setAttribute(
				'aria-describedby',
				'rebuy-quick-view-search-instructions',
			);
		}

		// Remove aria-label in rebuy-product-title
		const rebuyProductTitles = document.querySelectorAll(
			'.rebuy-product-title, .rebuy-product-title-link, .rebuy-product-actions .rebuy-button',
		);
		rebuyProductTitles.forEach(function (el) {
			el.removeAttribute('aria-label');
		});

		// Rebuy Ajax Cart ADA Fix
		const rebuyCartLists = document.querySelectorAll(
			'[data-rebuy-component="cart-items"] ul[role="list"], [data-rebuy-component="cart-items"] ul[role="group"]',
		);
		rebuyCartLists.forEach(function (ul) {
			ul.removeAttribute('role');
		});

		const rebuyCartProductTitles = document.querySelectorAll(
			'[data-rebuy-component="cart-items"] .rebuy-cart__flyout-item-product-title[role="heading"]',
		);
		rebuyCartProductTitles.forEach(function (link) {
			link.removeAttribute('role');
			link.removeAttribute('aria-level');

			if (
				link.tagName == 'H1' ||
				link.tagName == 'H2' ||
				link.tagName == 'H3' ||
				link.tagName == 'H4' ||
				link.tagName == 'H5' ||
				link.tagName == 'H6'
			)
				return;
			const parent = link.parentNode;
			const h3 = document.createElement('h3');
			h3.className = link.className;
			parent.insertBefore(h3, link);
			h3.appendChild(link);
		});

		const productBlocks = document.querySelectorAll('.rebuy-product-block');
		productBlocks.forEach(function (block) {
			if (!block.hasAttribute('role')) {
				block.setAttribute('role', 'group');
			}
			if (!block.hasAttribute('aria-label')) {
				block.setAttribute('aria-label', 'product');
			}
		});

		// Rebuy Ajax Cart Subtotal replace by h3
		const rebuyCartSubtotal = document.querySelector(
			'.rebuy-cart__flyout-subtotal-label span',
		);
		if (rebuyCartSubtotal) {
			const h3 = document.createElement('h3');
			h3.className = rebuyCartSubtotal.className;
			h3.textContent = rebuyCartSubtotal.textContent;
			rebuyCartSubtotal.parentNode.replaceChild(h3, rebuyCartSubtotal);
		}
	}, 500);
});

// document.addEventListener('rebuy.add', (event) => {
//   console.log(' ============ received rebuy.add event ==========')
// });

// document.addEventListener('rebuy.remove', (event) => {
//   console.log(' ============ received rebuy.remove event ==========')
// });

function handleRebuySearchAdaFix() {
	// Remove attributes from quick view overlay
	const rebuyQuickViewOverlay = document.querySelector(
		'#rebuy-quick-view-overlay',
	);
	rebuyQuickViewOverlay.removeAttribute('role');
	rebuyQuickViewOverlay.removeAttribute('aria-labelledby');
	rebuyQuickViewOverlay.removeAttribute('aria-describedby');

	// Visually hidden live region: announce result count when search results change
	let resultsCountEl = rebuyQuickViewOverlay.querySelector(
		'.results-count.sr-only',
	);
	if (!resultsCountEl) {
		resultsCountEl = document.createElement('div');
		resultsCountEl.className = 'results-count sr-only';
		resultsCountEl.setAttribute('aria-live', 'assertive');
		rebuyQuickViewOverlay.insertBefore(
			resultsCountEl,
			rebuyQuickViewOverlay.firstChild,
		);
	}
	setTimeout(() => {
		const collectionList = rebuyQuickViewOverlay.querySelectorAll(
			'.rebuy-quick-view__collection',
		);
		const productList = rebuyQuickViewOverlay.querySelectorAll(
			'.rebuy-quick-view__product',
		);
		const collectionCount = collectionList ? collectionList.length : 0;
		const productCount = productList ? productList.length : 0;
		const total = collectionCount + productCount;
		resultsCountEl.textContent =
			total === 0 ? 'No results available.' : total + ' results available.';
	}, 250);

	// Add h3 inside product title link (for accessibility)
	const rebuyProductTitles = rebuyQuickViewOverlay.querySelectorAll(
		'.rebuy-product-title',
	);
	rebuyProductTitles.forEach(function (anchor) {
		if (anchor.tagName !== 'A') return;
		const h3 = document.createElement('h3');
		while (anchor.firstChild) {
			h3.appendChild(anchor.firstChild);
		}
		anchor.appendChild(h3);
	});

	// Replace section title <p> with <h3> (Rebuy renders it as p.rebuy-quick-view__title)
	setTimeout(() => {
		const rebuyQuickViewTitles = rebuyQuickViewOverlay.querySelectorAll(
			'.rebuy-quick-view__title',
		);
		console.log('rebuyQuickViewTitles ', rebuyQuickViewTitles);
		rebuyQuickViewTitles.forEach(function (el) {
			if (el.tagName !== 'P') return;
			const h2 = document.createElement('h2');
			h2.className = el.className;
			while (el.firstChild) {
				h2.appendChild(el.firstChild);
			}
			el.parentNode.replaceChild(h2, el);
		});
	}, 250);

	// trap Focus on rebuy-quick-view-dropdown-search
	const rebuyQuicViewDropdownContainer = document.querySelector(
		'.rebuy-quick-view-dropdown__container',
	);
	if (rebuyQuicViewDropdownContainer) {
		setTimeout(() => {
			trapFocus(rebuyQuicViewDropdownContainer, rebuyQuicViewDropdownContainer);
		}, 250);
	}
}

const trapFocusHandlers = {};

function getFocusableElements(container, excludeSelector) {
	const allElements = Array.from(
		container.querySelectorAll(
			"summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe",
		),
	);

	if (excludeSelector) {
		return allElements.filter((el) => {
			const excludedParent = el.closest(excludeSelector);
			return !excludedParent;
		});
	}

	return allElements;
}
function trapFocus(
	container,
	elementToFocus = container,
	excludeSelector = null,
) {
	const initialElements = getFocusableElements(container, excludeSelector);
	if (initialElements.length === 0) return;

	removeTrapFocus();

	trapFocusHandlers.container = container;
	trapFocusHandlers.excludeSelector = excludeSelector;

	const getFocusBoundaries = () => {
		const currentContainer = trapFocusHandlers.container;
		if (!currentContainer) return null;

		const elements = getFocusableElements(
			currentContainer,
			trapFocusHandlers.excludeSelector,
		);
		console.log('haha', 'focusable elements', elements);
		if (elements.length === 0) return null;

		return {
			first: elements[0],
			last: elements[elements.length - 1],
			container: currentContainer,
		};
	};

	trapFocusHandlers.keydown = function (event) {
		if (event.code.toUpperCase() !== 'TAB') return;

		const boundaries = getFocusBoundaries();
		if (!boundaries) return;

		const { first, last, container: currentContainer } = boundaries;
		const activeElement = document.activeElement;

		if (!currentContainer.contains(activeElement)) {
			event.preventDefault();
			event.stopPropagation();
			first.focus();
			return;
		}

		if (event.shiftKey && activeElement === first) {
			event.preventDefault();
			event.stopPropagation();
			last.focus();
			return;
		}

		if (!event.shiftKey && activeElement === last) {
			event.preventDefault();
			event.stopPropagation();
			first.focus();
		}
	};

	trapFocusHandlers.focusin = (event) => {
		const boundaries = getFocusBoundaries();
		if (!boundaries) return;

		const { first, container: currentContainer } = boundaries;

		if (!currentContainer.contains(event.target)) {
			event.preventDefault();
			event.stopPropagation();
			first.focus();
		}
	};

	document.addEventListener('keydown', trapFocusHandlers.keydown, true);
	document.addEventListener('focusin', trapFocusHandlers.focusin, true);

	elementToFocus.focus();

	if (
		elementToFocus.tagName === 'INPUT' &&
		['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
		elementToFocus.value
	) {
		elementToFocus.setSelectionRange(0, elementToFocus.value.length);
	}
}
function removeTrapFocus(elementToFocus = null) {
	if (trapFocusHandlers.focusin) {
		document.removeEventListener('focusin', trapFocusHandlers.focusin, true);
	}
	if (trapFocusHandlers.focusout) {
		document.removeEventListener('focusout', trapFocusHandlers.focusout);
	}
	if (trapFocusHandlers.keydown) {
		document.removeEventListener('keydown', trapFocusHandlers.keydown, true);
	}

	if (elementToFocus) elementToFocus.focus();
}

// Register Page ADA – focus first field with an error so screen readers are informed
document.addEventListener('DOMContentLoaded', function () {
	setTimeout(handleRegisterPageAda, 500);
});
function handleRegisterPageAda() {
	const registerForm = document.querySelector(
		'.form-account form, #create_customer',
	);
	if (!registerForm) return;
	const firstError = registerForm.querySelector(
		'input.input-error, input[aria-invalid="true"]',
	);
	if (firstError) {
		setTimeout(() => {
			firstError.scrollIntoView({ behavior: 'instant', block: 'center' });
			firstError.focus();
		}, 1000);
	}

	const emailErrorInput = registerForm.querySelector('#Email.input-error');
	if (emailErrorInput) {
		emailErrorInput.setAttribute('aria-describedby', 'Email-error');
	}
	const passwordErrorInput = registerForm.querySelector(
		'#CreatePassword.input-error',
	);
	if (passwordErrorInput) {
		passwordErrorInput.setAttribute('aria-describedby', 'CreatePassword-error');
	}
}
